/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

/* hamburger icon effect */
function toggleNavMobile() {
  jQuery(".menu-header .hamburguer_icon").toggleClass("change");

  jQuery(".menu-header .menu-mobile").toggleClass("active");
  jQuery("footer .scroll-top-wrapper").toggleClass("dontShow");
  jQuery("body").toggleClass("hiddenOverflow");
}

//back to top
function scrollToTop() {
  verticalOffset = typeof verticalOffset !== "undefined" ? verticalOffset : 0;
  element = jQuery("body");
  offset = element.offset();
  offsetTop = offset.top;
  jQuery("html, body").animate(
    {
      scrollTop: offsetTop,
    },
    500,
    "linear"
  );
}

const smallMenu = jQuery(".menu-header > .container .nav-container .nav-small");
const mainMenu = jQuery(".menu-header > .container .nav-container .nav-main");
const mainMenuLi = jQuery(
  ".menu-header > .container .nav-container .nav-main > ul > li"
);
const subMenuesUl = jQuery(
  ".menu-header > .container .nav-container .nav-main > ul > ul.sub-menu"
);

function removeAllActiveMenu() {
  mainMenuLi.removeClass("active");
}

function removeAllActiveSubMenu() {
  subMenuesUl.removeClass("active");
}

function removeAllActiveMenuAndSubMenu() {
  removeAllActiveMenu();
  removeAllActiveSubMenu();
}

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage;
  Sage = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages

        $('.grid-item-slider').each(function () {
          var slider2 = $(this).find('.items')[0];
          $(slider2).niceScroll({
            cursorcolor: '#d33138',
            autohidemode: false,
            enablemousewheel: false,
            cursorwidth: "7px",
            background: "#c3c5c6",
            cursorborder: "none",
            cursorborderradius: "0px"
          });
          var isDown = false;
          var startX;
          var scrollLeft;
          slider2.addEventListener('mousedown', function (e) {
            isDown = true;
            slider2.classList.add('active');
            startX = e.pageX - slider2.offsetLeft;
            scrollLeft = slider2.scrollLeft;
          });
          slider2.addEventListener('mouseleave', function () {
            isDown = false;
            slider2.classList.remove('active');
          });
          slider2.addEventListener('mouseup', function () {
            isDown = false;
            slider2.classList.remove('active');
          });
          slider2.addEventListener('mousemove', function (e) {
            if (!isDown) return
            e.preventDefault();
            const x = e.pageX - slider2.offsetLeft;
            const walk = (x - startX) * 1.3; //scroll-fast
            slider2.scrollLeft = scrollLeft - walk;
            if (slider2.scrollLeft !== (slider2.scrollWidth - slider2.clientWidth)) {
              $(this).parent().find('.next-test-button').show();
            }
          });

          $_minus = 0;
          $_pos = 0;
          if ($(window).width() > 767) {
            $(this).find('.next-test-button').css({'width': $(slider2).find('div').width() / 2.5 + 'px'});
            $(this).find('.next-test-button').click(function (e) {
              $_tot = slider2.scrollLeft + $(slider2).find('div').width() + 30;

              var $move = setInterval(function(){
              // console.log(slider2.scrollLeft)
                if (slider2.scrollLeft < $_tot && (slider2.scrollLeft !== (slider2.scrollWidth - slider2.clientWidth))) {
                  slider2.scrollLeft += 10;
                } else {
                  clearInterval($move);
                }
              }, 10);

              if (slider2.scrollLeft+$(slider2).find('div').width() > (slider2.scrollWidth - slider2.clientWidth)) {
                $(this).hide();
                $_minus = 200;
              } else {
                $(this).show();
              }

              $('.fixed-img-top .fix-item').eq($_pos).fadeOut();
              $('.fixed-img-bottom .fix-item').eq($_pos).fadeOut();
              $_pos += 1;
              $('.fixed-img-top .fix-item').eq($_pos).fadeIn();
              $('.fixed-img-bottom .fix-item').eq($_pos).fadeIn();

            });
            $(this).find('.prev-test-button').css({'width': $(slider2).find('div').width() / 3 + 'px'});
            $(this).find('.prev-test-button').click(function (e) {
              $(this).parent().find('.next-test-button').show();
              // slider2.scrollLeft -= $(slider2).find('div').width() / 1.2;
              $_tot = slider2.scrollLeft - $(slider2).find('div').width() - 30 + $_minus;

              var $move = setInterval(function(){
                if ($_tot < slider2.scrollLeft && (slider2.scrollLeft !== 0)) {
                  slider2.scrollLeft -= 10;
                } else {
                  clearInterval($move);
                  $_minus = 0;
                  if (slider2.scrollLeft === 0) {
                    $(this).hide();
                  } else {
                    $(this).show();
                  }
                }
              }, 10);

              $('.fixed-img-top .fix-item').eq($_pos).fadeOut();
              $('.fixed-img-bottom .fix-item').eq($_pos).fadeOut();
              $_pos -= 1;
              $('.fixed-img-top .fix-item').eq($_pos).fadeIn();
              $('.fixed-img-bottom .fix-item').eq($_pos).fadeIn();
            });
          }
        });

        var sliderSolutionWindowWidth2 = $(window).width();
        var sliderSolutionSliderWidth2 = $(".container").width();
        var sliderSolutionWidthFixed2 =
          (sliderSolutionWindowWidth2 - sliderSolutionSliderWidth2) / 2;
        $(".grid-item-slider").each(function (index) {
          if (window.location.pathname.includes('/blog/') || window.location.pathname.includes('/human-resources') || window.location.pathname.includes('/עמיעד-כח-אדם')) {
            $(this).css({
              width: "calc(100% + " + sliderSolutionWidthFixed2 + "px) ",
              // paddingRight: sliderSolutionWidthFixed2 + "px",
            });
          } else {
            $(this).css({
              marginLeft: sliderSolutionWidthFixed2 + "px ",
            });
          }
        });


        var wow = new WOW({
          boxClass: "wow", // animated element css class (default is wow)
          animateClass: "animated", // animation css class (default is animated)
          offset: 0, // distance to the element when triggering the animation (default is 0)
          mobile: true, // trigger animations on mobile devices (default is true)
          live: true, // act on asynchronously loaded content (default is true)
          callback: function (box) {
            // the callback is fired every time an animation is started
            // the argument that is passed in is the DOM node being animated
          },
          scrollContainer: null, // optional scroll container selector, otherwise use window,
          resetAnimation: true, // reset animation on end (default is true)
        });
        wow.init();

        // Initialize AOS
        AOS.init({
          offset: 0,
          duration: 400,
          delay: 0,
          once: false,
          disable: function () {
            if ($(".sg-body").length) {
              return true;
            }
          },
        });

        var $document = $(document),
          $btn_scroll_top = $("footer .scroll-top-wrapper"),
          classNameBtnScrollTop = "show";

        $document.scroll(function () {
          //show scrollTop button
          if ($document.scrollTop() >= 100) {
            // user scrolled 50 pixels or more;
            // do stuff
            $btn_scroll_top.addClass(classNameBtnScrollTop);
          } else {
            $btn_scroll_top.removeClass(classNameBtnScrollTop);
          }
        });

        //bg Parallax
        function bgParallax() {
          var scrollAmount = $(window).scrollTop();
          var windowsize = $(window).width();
          //Only parallax on tablet landscape and higher
          if (windowsize >= 980) {
            $('.has-parallax').each(function () {
              var scrolled = (($(this).offset().top - scrollAmount) * 0.13) + 'px';
              $(this).css({"transform": "translate(0," + scrolled + ")"});
            });
          } else {
            $('.has-parallax').each(function () {
              $(this).css({"transform": "translate(0px,0px)"});
            });
          }
        }

        $(window).on('scroll', function () {
          bgParallax();
        });

        $btn_scroll_top.on("click", scrollToTop);

        // send search on click the icon
        $("#lupa-search").on("click", function () {
          $(this).parent().submit();
        });

        //show search form
        $(".menu-header .nav-main .menu-search a").on("click", function (e) {
          e.preventDefault();
          $(".form-search-container .search-field").val("");
          $("body .form-search-container").toggleClass("search-active");
          $("body .form-search-container form").css('display', 'flex');
          $("body .form-search-container .search-header").css('display', 'flex');
          $("body .form-search-container form input").focus();
        });

        $("body .form-search-container .close-search-form").on(
          "click",
          function (e) {
            $("body .form-search-container").removeClass("search-active");

            $("body .form-search-container form").css('display', 'none');
            $("body .form-search-container .search-header").css('display', 'none');
          }
        );

        // **********************************************
        //    DESKTOP MENU FUNCTIONALITY
        // **********************************************

        //Activate SubMenu on Hover
        mainMenuLi.on("mouseover", function () {
          var thisMenu = $(this);

          if (!thisMenu.hasClass("active")) {
            removeAllActiveMenuAndSubMenu();

            thisMenu.toggleClass("active");

            if (thisMenu.hasClass("has_submenu")) {
              var thisSubMenu = thisMenu.next("ul.sub-menu");
              var horizontalLine = thisSubMenu.find(".horizontal-line");

              thisSubMenu.addClass("active");
              horizontalLine.css(
                "top",
                $(".sub-menu.active .sub-menu-column h5").outerHeight() +
                ($(".sub-menu.active .sub-menu-column").length?$(".sub-menu.active .sub-menu-column").position().top:'')
              );
            }
          }
        });

        //remain active the menu
        subMenuesUl.on("mouseover", function () {
          var subMenuHover = $(this);
          var thisMenuActive = $(this).prev();

          if (!subMenuHover.hasClass("active")) {
            subMenuHover.addClass("active");
          }

          if (!thisMenuActive.hasClass("active")) {
            thisMenuActive.addClass("active");
          }
        });

        smallMenu.on("mouseover", function () {
          removeAllActiveMenuAndSubMenu();
        });

        mainMenu.on("mouseleave", function () {
          removeAllActiveMenuAndSubMenu();
        });

        //deactivate all menus and submenu when clicking outside
        $(".wrap").on("click", function () {
          removeAllActiveMenuAndSubMenu();
        });

        //deactivate all menus and submenu when scroll
        $document.scroll(function () {
          removeAllActiveMenuAndSubMenu();
        });

        setTimeout(function () {

            if ( $(".sub-menu").hasClass("two-columns-padding") ) {
              $(".sub-menu").css({
                "padding-left": $(".nav-container").position().left + "px",
                "justify-content": "flex-start",
              });
            } else {
              $(".sub-menu").css({
                padding: "15px 0",
                "justify-content": "center",
              });
            }

            $(".sub-menu .horizontal-line").css(
              "top",
              $(".sub-menu-column h3").outerHeight() +
              ($(".sub-menu-column").length?$(".sub-menu-column").position().top:'')
            );

        }, 500);

        $(window).resize(function () {
          $(".sub-menu.two-columns-padding").css({
            "padding-left": $(".nav-container").position().left,
          });


        });

        // **********************************************
        //    DESKTOP SUBMENU FUNCTIONALITY
        // **********************************************

        $(".sub-menu .right-column .secondary-menu > a").on("click", function (
          e
        ) {
          e.preventDefault();
          $(this).parent().toggleClass("active");
          $(this)
            .closest(".primary-menu-row")
            .find(".left-column a")
            .css("background-color", "#f6f6f6");

          var secondary_menu_icon = $(this).find(".fas");

          if ($(this).parent().hasClass("active")) {
            secondary_menu_icon.removeClass("fa-caret-right");
            secondary_menu_icon.addClass("fa-caret-down");
            $(this)
              .closest(".primary-menu-row")
              .find(".left-column a")
              .css("background-color", "#f6f6f6");
          } else {
            secondary_menu_icon.removeClass("fa-caret-down");
            secondary_menu_icon.addClass("fa-caret-right");
            $(this)
              .closest(".primary-menu-row")
              .find(".left-column a")
              .css("background-color", "#ffffff");
          }
        });

        if ($(".sub-menu").hasClass("two-columns-padding")) {
          $(".sub-menu").css({
            "padding-left": $(".nav-container").position().left + 10,
          });
        } else {
          $(".sub-menu").css({"padding-left": "15px"});
        }

        // **********************************************
        //    MOBILE MENU FUNCTIONALITY
        // **********************************************

        $(".menu-mobile .nav-main ul.first-lvl-ul > li.has_submenu").on(
          "click", function (e) {
            e.preventDefault();
            $(this).toggleClass("less-padding");
            $(this).children("i").toggleClass("d-none");
            var sub_menu_mobile_active = $(this).next(".sub-menu");
            sub_menu_mobile_active.toggleClass("active");

            $(this).siblings("li").toggleClass("d-none");

            if (sub_menu_mobile_active.hasClass("active")) {
              sub_menu_mobile_active.css({
                position: "relative",
                left: "0",
              });
            } else {
              sub_menu_mobile_active.css({
                left: "100%",
              });
              setTimeout(function () {
                sub_menu_mobile_active.css("position", "absolute");
              }, 300);
            }
          }
        );

        $(".menu-mobile .nav-main ul.third-lvl-ul > li.has_submenu").on(
          "click", function (e) {
            e.preventDefault();
            $(this).find('i').toggleClass("fa-caret-down");
            $(this).find('i').toggleClass("fa-caret-right");
            $(this).toggleClass("active");

            var sub_sub_menu_mobile_active = $(this).next(".sub-sub-menu");
            var sub_sub_menu_ul = sub_sub_menu_mobile_active.find(".fourth-lvl-ul");

            sub_sub_menu_mobile_active.toggleClass("active");

            if (sub_sub_menu_mobile_active.hasClass("active")) {
              sub_sub_menu_mobile_active.css("display", "block");
              setTimeout(function () {
                sub_sub_menu_ul.css({
                  transform: "translateY(0%)",
                });
              }, 100);
            } else {
              sub_sub_menu_ul.css({
                transform: "translateY(-100%)",
              });
              setTimeout(function () {
                sub_sub_menu_mobile_active.css("display", "none");
              }, 200);
            }
          }
        );

        $(".menu-mobile .nav-main ul.fourth-lvl-ul > li.has_submenu > div:first-child").on(
          "click", function (e) {
          e.preventDefault();
          $(this).find('i').toggleClass("fa-caret-down");
          $(this).find('i').toggleClass("fa-caret-right");

          var last_ul = $(this).parent().find("ul").toggleClass("active");

          if (last_ul.hasClass("active")) {
            last_ul.css("display", "block");
            setTimeout(function () {
              last_ul.css({
                transform: "translateY(0%)",
              });
            }, 100);
          } else {
            last_ul.css({
              transform: "translateY(-115%)",
            });
            setTimeout(function () {
              last_ul.css("display", "none");
            }, 200);
          }
        });

        $(window).resize(function () {
          $(".sub-menu.two-columns-padding").css({
            "padding-left": $(".nav-container").position().left,
          });
        });

        //show on/off menu-sticky on scroll
        $(window).bind("scroll", function () {
          if ($(window).scrollTop() > 60) {
            $(".menu-header").addClass("sticky");
          } else {
            $(".menu-header").removeClass("sticky");
          }
        });

        /////////////////////////////////////
        //SLIDERS SCRIPTS//////////
        const slider = $(".inner-items");

        slider.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          rtl: $('body').hasClass('rtl'),
          autoplaySpeed: 2000,
          arrow: false,
          infinite: false,
          speed: 300,
          // variableWidth: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                rtl: $('body').hasClass('rtl'),
                variableWidth: false,
              },
            },
          ],
        });

        ///////////////FIX SLIDER/////////////////
        ///////////////FIX SLIDER/////////////////
        // var sliderSolutionWindowWidth = $(window).width();
        // var sliderSolutionSliderWidth = $(".fixed-position-slider").width();
        // var sliderSolutionWidthFixed =
        //   (sliderSolutionWindowWidth - sliderSolutionSliderWidth) / 2;
        // $(".fixed-position-slider").each(function (index) {
        //   $(this).css({
        //     width: "calc(100% + " + sliderSolutionWidthFixed + "px ",
        //   });
        // });
        ///////////////FIX SLIDER/////////////////
        ///////////////FIX SLIDER/////////////////

        if ($(window).width() < 1405) {
          $(".block-container .list").slick({
            dots: false,
            centerMode: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            rtl: $('body').hasClass('rtl'),
            infinite: true,
            variableWidth: true,
            arrows:false,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 2,
                },
              },
              {
                breakpoint: 767,
                settings: {
                  dots: true,
                  slidesToShow: 1,
                  arrows:true,
                },
              },
              {
                breakpoint: 430,
                settings: {
                  dots: true,
                  centerMode: true,
                  arrows:true,
                },
              },
            ],
          });
        }

        // SCROLL SLIDER SE SACO POR PEDIDO CLIENTE
        // slider.on("wheel", function (e) {
        //   e.preventDefault();
        //
        //   if (e.originalEvent.deltaY < 0) {
        //     $(this).slick("slickNext");
        //   } else {
        //     $(this).slick("slickPrev");
        //   }
        // });

        /////////////////////////////////////
        /////////////////////////////////////

        //SLIDER PROMOTED POSTS IN BLOG LOBBY
        if ($(window).width() < 993) {
          /* the viewport is less than 768 pixels wide */
          $(".mobile-slider-promoted").slick({
            dots: false,
            prevArrow: false,
            // nextArrow: false,
            centerMode: true,
          });

          $(".mobile-slider-promoted ").on("swipe", function () {
            $(".mobile-slider-promoted .block").removeClass("block-active");
            $(".mobile-slider-promoted .slick-active").addClass("block-active");
          });

          $(".slick-next").on("click", function () {
            $(".mobile-slider-promoted .block").removeClass("block-active");
            $(".mobile-slider-promoted .slick-active").addClass("block-active");
          });
        }

        /////////////////////////////////////
        /////////////////////////////////////

        //SLIDER PROMOTED POSTS IN BLOG LOBBY
        if ($(window).width() < 993) {
          $(".list-block-cert .items-container").slick({
            dots: false,
            prevArrow: false,
            nextArrow: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            rtl: $('body').hasClass('rtl'),
          });
        }

        /////////////////////////////////////
        /////////////////////////////////////

        //SLIDER OUR EVENTS POSTS IN NEWS & EVENTS

        $("#link-event-01").click(function () {
          if($(window).width() < 767){
            $(this).hide(500);
          }
          $("#info-event-01").show("fast");
          $("#info-event-02").hide(500);
          $("#info-event-03").hide(500);
          $("#info-event-04").hide(500);
          $("#info-event-05").hide(500);
          $("#info-event-06").hide(500);
          $("#info-event-07").hide(500);
          $("#info-event-08").hide(500);
          $("#info-event-09").hide(500);
          $("#info-event-10").hide(500);
          $("#info-event-11").hide(500);
          $("#info-event-12").hide(500);
        });

        $("#close-info-event-01").click(function () {
          $("#inner-info-event-01").css({transform: "translateY(0)"});
          $("#info-event-01").hide(500);
          if($(window).width() < 767){
            $("#link-event-01").show(500);
          }
        });

        $("#more-info-event-01").click(function () {
          $("#inner-info-event-01").css({transform: "translateY(-30%)"});
        });
        /////////////////////////////////////

        $("#link-event-02").click(function () {
          if($(window).width() < 767){
            $(this).hide(500);
          }
          $("#info-event-02").show("fast");
          $("#info-event-01").hide(500);
          $("#info-event-03").hide(500);
          $("#info-event-04").hide(500);
          $("#info-event-05").hide(500);
          $("#info-event-06").hide(500);
          $("#info-event-07").hide(500);
          $("#info-event-08").hide(500);
          $("#info-event-09").hide(500);
          $("#info-event-10").hide(500);
          $("#info-event-11").hide(500);
          $("#info-event-12").hide(500);
        });

        $("#close-info-event-02").click(function () {
          $("#inner-info-event-02").css({transform: "translateY(0)"});
          $("#info-event-02").hide(500);
          if($(window).width() < 767){
            $("#link-event-02").show(500);
          }
        });

        $("#more-info-event-02").click(function () {
          $("#inner-info-event-02").css({transform: "translateY(-30%)"});
        });
        /////////////////////////////////////

        $("#link-event-03").click(function () {
          if($(window).width() < 767){
            $(this).hide(500);
          }
          $("#info-event-03").show("fast");
          $("#info-event-02").hide(500);
          $("#info-event-01").hide(500);
          $("#info-event-04").hide(500);
          $("#info-event-05").hide(500);
          $("#info-event-06").hide(500);
          $("#info-event-07").hide(500);
          $("#info-event-08").hide(500);
          $("#info-event-09").hide(500);
          $("#info-event-10").hide(500);
          $("#info-event-11").hide(500);
          $("#info-event-12").hide(500);
        });

        $("#close-info-event-03").click(function () {
          $("#inner-info-event-03").css({transform: "translateY(0)"});
          $("#info-event-03").hide(500);
          if($(window).width() < 767){
            $("#link-event-03").show(500);
          }
        });

        $("#more-info-event-03").click(function () {
          $("#inner-info-event-03").css({transform: "translateY(-30%)"});
        });
        /////////////////////////////////////

        $("#link-event-04").click(function () {
          if($(window).width() < 767){
            $(this).hide(500);
          }
          $("#info-event-04").show("fast");
          $("#info-event-01").hide(500);
          $("#info-event-02").hide(500);
          $("#info-event-03").hide(500);
          $("#info-event-05").hide(500);
          $("#info-event-06").hide(500);
          $("#info-event-07").hide(500);
          $("#info-event-08").hide(500);
          $("#info-event-09").hide(500);
          $("#info-event-10").hide(500);
          $("#info-event-11").hide(500);
          $("#info-event-12").hide(500);
        });

        $("#close-info-event-04").click(function () {
          $("#inner-info-event-04").css({transform: "translateY(0)"});
          $("#info-event-04").hide(500);
          if($(window).width() < 767){
            $("#link-event-04").show(500);
          }
        });

        $("#more-info-event-04").click(function () {
          $("#inner-info-event-04").css({transform: "translateY(-30%)"});
        });
        /////////////////////////////////////

        $("#link-event-05").click(function () {
          if($(window).width() < 767){
            $(this).hide(500);
          }
          $("#info-event-05").show("fast");
          $("#info-event-01").hide(500);
          $("#info-event-02").hide(500);
          $("#info-event-03").hide(500);
          $("#info-event-04").hide(500);
          $("#info-event-06").hide(500);
          $("#info-event-07").hide(500);
          $("#info-event-08").hide(500);
          $("#info-event-09").hide(500);
          $("#info-event-10").hide(500);
          $("#info-event-11").hide(500);
          $("#info-event-12").hide(500);
        });

        $("#close-info-event-05").click(function () {
          $("#inner-info-event-05").css({transform: "translateY(0)"});
          $("#info-event-05").hide(500);
          if($(window).width() < 767){
            $("#link-event-05").show(500);
          }
        });

        $("#more-info-event-05").click(function () {
          $("#inner-info-event-05").css({transform: "translateY(-30%)"});
        });
        /////////////////////////////////////

        $("#link-event-06").click(function () {
          if($(window).width() < 767){
            $(this).hide(500);
          }
          $("#info-event-06").show("fast");
          $("#info-event-01").hide(500);
          $("#info-event-02").hide(500);
          $("#info-event-03").hide(500);
          $("#info-event-04").hide(500);
          $("#info-event-05").hide(500);
          $("#info-event-07").hide(500);
          $("#info-event-08").hide(500);
          $("#info-event-09").hide(500);
          $("#info-event-10").hide(500);
          $("#info-event-11").hide(500);
          $("#info-event-12").hide(500);
        });

        $("#close-info-event-06").click(function () {
          $("#inner-info-event-06").css({transform: "translateY(0)"});
          $("#info-event-06").hide(500);
          if($(window).width() < 767){
            $("#link-event-06").show(500);
          }
        });

        $("#more-info-event-06").click(function () {
          $("#inner-info-event-06").css({transform: "translateY(-30%)"});
        });
        /////////////////////////////////////

        $("#link-event-07").click(function () {
          if($(window).width() < 767){
            $(this).hide(500);
          }
          $("#info-event-07").show("fast");
          $("#info-event-01").hide(500);
          $("#info-event-02").hide(500);
          $("#info-event-03").hide(500);
          $("#info-event-04").hide(500);
          $("#info-event-05").hide(500);
          $("#info-event-06").hide(500);
          $("#info-event-08").hide(500);
          $("#info-event-09").hide(500);
          $("#info-event-10").hide(500);
          $("#info-event-11").hide(500);
          $("#info-event-12").hide(500);
        });

        $("#close-info-event-07").click(function () {
          $("#inner-info-event-07").css({transform: "translateY(0)"});
          $("#info-event-07").hide(500);
          if($(window).width() < 767){
            $("#link-event-07").show(500);
          }
        });

        $("#more-info-event-07").click(function () {
          $("#inner-info-event-07").css({transform: "translateY(-30%)"});
        });
        /////////////////////////////////////

        $("#link-event-08").click(function () {
          if($(window).width() < 767){
            $(this).hide(500);
          }
          $("#info-event-08").show("fast");
          $("#info-event-01").hide(500);
          $("#info-event-02").hide(500);
          $("#info-event-03").hide(500);
          $("#info-event-04").hide(500);
          $("#info-event-05").hide(500);
          $("#info-event-06").hide(500);
          $("#info-event-07").hide(500);
          $("#info-event-09").hide(500);
          $("#info-event-10").hide(500);
          $("#info-event-11").hide(500);
          $("#info-event-12").hide(500);
        });

        $("#close-info-event-08").click(function () {
          $("#inner-info-event-08").css({transform: "translateY(0)"});
          $("#info-event-08").hide(500);
          if($(window).width() < 767){
            $("#link-event-08").show(500);
          }
        });

        $("#more-info-event-08").click(function () {
          $("#inner-info-event-08").css({transform: "translateY(-30%)"});
        });
        /////////////////////////////////////

        $("#link-event-09").click(function () {
          if($(window).width() < 767){
            $(this).hide(500);
          }
          $("#info-event-09").show("fast");
          $("#info-event-01").hide(500);
          $("#info-event-02").hide(500);
          $("#info-event-03").hide(500);
          $("#info-event-04").hide(500);
          $("#info-event-05").hide(500);
          $("#info-event-06").hide(500);
          $("#info-event-07").hide(500);
          $("#info-event-08").hide(500);
          $("#info-event-10").hide(500);
          $("#info-event-11").hide(500);
          $("#info-event-12").hide(500);
        });

        $("#close-info-event-09").click(function () {
          $("#inner-info-event-09").css({transform: "translateY(0)"});
          $("#info-event-09").hide(500);
          if($(window).width() < 767){
            $("#link-event-09").show(500);
          }
        });

        $("#more-info-event-09").click(function () {
          $("#inner-info-event-09").css({transform: "translateY(-30%)"});
        });
        /////////////////////////////////////

        $("#link-event-10").click(function () {
          if($(window).width() < 767){
            $(this).hide(500);
          }
          $("#info-event-10").show("fast");
          $("#info-event-01").hide(500);
          $("#info-event-02").hide(500);
          $("#info-event-03").hide(500);
          $("#info-event-04").hide(500);
          $("#info-event-05").hide(500);
          $("#info-event-06").hide(500);
          $("#info-event-07").hide(500);
          $("#info-event-08").hide(500);
          $("#info-event-09").hide(500);
          $("#info-event-11").hide(500);
          $("#info-event-12").hide(500);
        });

        $("#close-info-event-10").click(function () {
          $("#inner-info-event-10").css({transform: "translateY(0)"});
          $("#info-event-10").hide(500);
          if($(window).width() < 767){
            $("#link-event-10").show(500);
          }
        });

        $("#more-info-event-10").click(function () {
          $("#inner-info-event-10").css({transform: "translateY(-30%)"});
        });

        /////////////////////////////////////

        $("#link-event-11").click(function () {
          if($(window).width() < 767){
            $(this).hide(500);
          }
          $("#info-event-11").show("fast");
          $("#info-event-01").hide(500);
          $("#info-event-02").hide(500);
          $("#info-event-03").hide(500);
          $("#info-event-04").hide(500);
          $("#info-event-05").hide(500);
          $("#info-event-06").hide(500);
          $("#info-event-07").hide(500);
          $("#info-event-08").hide(500);
          $("#info-event-09").hide(500);
          $("#info-event-10").hide(500);
          $("#info-event-12").hide(500);
        });

        $("#close-info-event-11").click(function () {
          $("#inner-info-event-11").css({transform: "translateY(0)"});
          $("#info-event-11").hide(500);
          if($(window).width() < 767){
            $("#link-event-11").show(500);
          }
        });

        $("#more-info-event-11").click(function () {
          $("#inner-info-event-11").css({transform: "translateY(-30%)"});
        });
        /////////////////////////////////////

        $("#link-event-12").click(function () {
          if($(window).width() < 767){
            $(this).hide(500);
          }
          $("#info-event-12").show("fast");
          $("#info-event-01").hide(500);
          $("#info-event-02").hide(500);
          $("#info-event-03").hide(500);
          $("#info-event-04").hide(500);
          $("#info-event-05").hide(500);
          $("#info-event-06").hide(500);
          $("#info-event-07").hide(500);
          $("#info-event-08").hide(500);
          $("#info-event-09").hide(500);
          $("#info-event-11").hide(500);
        });

        $("#close-info-event-12").click(function () {
          $("#inner-info-event-12").css({transform: "translateY(0)"});
          $("#info-event-12").hide(500);
          if($(window).width() < 767){
            $("#link-event-12").show(500);
          }
        });

        $("#more-info-event-12").click(function () {
          $("#inner-info-event-12").css({transform: "translateY(-30%)"});
        });

        ////////////////////////////////////////////
        //FUNCIONALIDAD PARA EL BLOQUE MULTIMEDIA///
        $(".clip-play-icon").click(function () {
          $(".modal-clip").css("display", "flex");
          $("body").css("overflow-y", "hidden");
        });

        $(".modal-clip").click(function () {
          $(".modal-clip").css("display", "none");
          $(".yvideo").each(function () {
            $(this).attr("src", $(this).attr("src"));
            return false;
          });
          $("body").css("overflow-y", "scroll");
        });

        /////////////////////////////////////
        // Country Selector
        /////////////////////////////////////
        // Show country selector modal when click on menu item
        $("li.select-country").click(function () {
          $(".country-selector-background").addClass("show");
          $('body').addClass('overflow-hidden');
        });
        // Close country selector modal when click on X
        $(".country-selector .close-button").click(function () {
          $(".country-selector-background").removeClass("show");
          $('body').removeClass('overflow-hidden');

        });
        /////////////////////////////////////
        // End of Country Selector
        /////////////////////////////////////

        /////////////////////////////////////
        // Highlight currently active menu item
        /////////////////////////////////////
        $(function () {
          // console.log("function entered");

          var url = window.location.pathname,
            //urlRegExp = new RegExp(url.replace(/\/$/, "") + "$");
            urlRegExp = new RegExp((url === "/") ? window.location.origin + "/?$" : url.replace(/\/$/, "") + "$");

          $(".menu-header a").each(function () {
            if (urlRegExp.test(this.href.replace(/\/$/, ""))) {
              $(this).addClass("active");
              // console.log("MESAGE");
            }
          });
        });
        /////////////////////////////////////
        // End of Highlight
        /////////////////////////////////////
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        //scroll to breadcrumb (used in Hero Arrow)
        $(document).ready(function () {
          $(".scrollToBreadcrumb").click(function (e) {
            e.preventDefault();
            $("html, body").animate(
              {
                scrollTop: jQuery(".breadcrumb-amiad").offset().top,
              },
              1500
            );
          });
        });
      },
    },

    // Home page
    home: {
      init: function () {
        ////////////////////////////////////////////
        //FUNCIONALIDAD HERO HOME///////////////////

        var mouseOverButtons = false;
        var mouseOverWichButton = "";
        $("#mainHeroSlider").css({backgroundSize: '110%'});

        if (!mainBg) {
          //DESKTOP NO MAIN
          //currentSegment ->
          // 0 = irrigation;
          // 1 = industry;
          var currentSegment = 0; //irrigation
          var currentSegmentImage = 0; //irrigation->image[0]

          var mixBg = [];
          var hovering = false;
          var whichHovering = 0;

          var animationSpeed50 = 1;

          // console.log(mixBg);

          if ($(window).width() > 767) {
            if (bgIrrigationImageDesktop && bgIndustrialImageDesktop) {
              //currentSegment ->
              // 0 = irrigation;
              // 1 = industry;

              mixBg.push(bgIrrigationImageDesktop);
              mixBg.push(bgIndustrialImageDesktop);

              $("#mainHeroSlider").css(
                "background-image",
                "url('" + mixBg[currentSegment][currentSegmentImage] + "')"
              );




              //ANIMACION ZOOMIN INICIO SLIDER
              // $("#mainHeroSlider").css({'background-size': '100%'});
              // $("#mainHeroSlider").animate({backgroundSize: '120%'}, 4500);



              // setInterval(function(){$("#mainHeroSlider").animate({backgroundSize: '110%'}, 4500);}, 6500)
              // var fixBgSize = setInterval(function(){ console.log('sale'); $("#mainHeroSlider").animate({backgroundSize: '110%'}, 4500); }, 4500);

              var myFunction = function() {

                //ANIMACIONES VIEJAS
                // $("#mainHeroSlider").animate({backgroundSize: '120%'}, 2500);

                if (!hovering) {
                  $("#mainHeroSlider").fadeOut(1000 / animationSpeed50, function () {
                    $("#mainHeroSlider").css({
                      "background-image": "url('" + mixBg[currentSegment][currentSegmentImage] + "')",
                      "z-index": 4
                    });

                    $("#mainHeroSlider").fadeIn(1000 / animationSpeed50);
                  });
                  if (
                    currentSegment === 0 &&
                    currentSegmentImage < bgIrrigationImageDesktop.length - 1
                  ) {
                    currentSegmentImage = currentSegmentImage + 1;
                  } else if (
                    currentSegment === 1 &&
                    currentSegmentImage < bgIndustrialImageDesktop.length - 1
                  ) {
                    currentSegmentImage = currentSegmentImage + 1;
                  } else {
                    //es igual
                    if (currentSegment !== 1) {
                      currentSegmentImage = 0;
                      currentSegment = currentSegment + 1;
                    } else {
                      currentSegmentImage = 0;
                      currentSegment = 0;
                    }
                  }
                } else {
                  $("#mainHeroSlider").fadeOut(500 / animationSpeed50, function () {
                    $("#mainHeroSlider").css(
                      "background-image",
                      "url('" + mixBg[whichHovering][currentSegmentImage] + "')"
                    );
                    $("#mainHeroSlider").fadeIn(500 / animationSpeed50);
                  });
                  if (currentSegmentImage < mixBg[whichHovering].length - 1) {
                    currentSegmentImage = currentSegmentImage + 1;
                  } else {
                    //es igual
                    currentSegmentImage = 0;
                  }
                }

                //ANIMACIONES VIEJAS
                // $("#mainHeroSlider").animate({backgroundSize: '110%'}, 0);

                setTimeout(myFunction, 3800 / animationSpeed50);
              };


              $("#irrigation-hover").hover(
                function () {
                  whichHovering = 0;
                  currentSegmentImage = 0;
                  hovering = true;
                  animationSpeed50 = 2;
                  $("#mainHeroSlider").fadeOut(500 / animationSpeed50, function () {
                    $("#mainHeroSlider").css(
                      "background-image",
                      "url('" + mixBg[whichHovering][currentSegmentImage] + "')"
                    );
                    $("#mainHeroSlider").fadeIn(500 / animationSpeed50);
                  });
                  if (currentSegmentImage < mixBg[whichHovering].length - 1) {
                    currentSegmentImage = currentSegmentImage + 1;
                  } else {
                    //es igual
                    currentSegmentImage = 0;
                  }
                  clearInterval(myFunction);
                },

                function () {
                  whichHovering = 0;
                  currentSegmentImage = 0;
                  hovering = false;
                  animationSpeed50 = 1;
                }
              );

              $("#industry-hover").hover(
                function () {
                  whichHovering = 1;
                  currentSegmentImage = 0;
                  hovering = true;
                  animationSpeed50 = 2;
                  $("#mainHeroSlider").fadeOut(500 / animationSpeed50, function () {
                    $("#mainHeroSlider").css(
                      "background-image",
                      "url('" + mixBg[whichHovering][currentSegmentImage] + "')"
                    );
                    $("#mainHeroSlider").fadeIn(500 / animationSpeed50);
                  });
                  if (currentSegmentImage < mixBg[whichHovering].length - 1) {
                    currentSegmentImage = currentSegmentImage + 1;
                  } else {
                    //es igual
                    currentSegmentImage = 0;
                  }
                  clearInterval(myFunction);
                },
                function () {
                  whichHovering = 0;
                  currentSegmentImage = 0;
                  hovering = false;
                  animationSpeed50 = 1;
                }
              );

              setTimeout(myFunction, 3800 / animationSpeed50);


              // var myFunction2 = function() {
              //   console.log('entra anima')
                //ANIMACIONES VIEJAS
                // $("#mainHeroSlider").animate({backgroundSize: '120%'}, 2500);
                //ANIMACIONES VIEJAS
                // $("#mainHeroSlider").animate({backgroundSize: '110%'}, 0);
                // setTimeout(myFunction2, 6500 / animationSpeed50);
              // }
              // setTimeout(myFunction2, 6500 / animationSpeed50);


            } else {
              console.log("ERROR: empty vars");
              return 0;
            }
          } else {
            //MOBILE NO MAIN

            if (bgIrrigationImageDesktop && bgIndustrialImageDesktop) {
              mixBg.push(bgIrrigationImageMobile);
              mixBg.push(bgIndustrialImageMobile);

              $("#mainHeroSlider").css(
                "background-image",
                "url('" + mixBg[currentSegment][currentSegmentImage] + "')"
              );

              setInterval(function () {
                $("#mainHeroSlider").fadeOut(1000, function () {
                  $("#mainHeroSlider").css(
                    "background-image",
                    "url('" + mixBg[currentSegment][currentSegmentImage] + "')"
                  );
                  $("#mainHeroSlider").fadeIn(1000);
                });
                if (
                  currentSegmentImage === 0 &&
                  currentSegmentImage < bgIrrigationImageMobile.length - 1
                ) {
                  currentSegmentImage = currentSegmentImage + 1;
                } else if (
                  currentSegmentImage === 1 &&
                  currentSegmentImage < bgIndustrialImageMobile.length - 1
                ) {
                  currentSegmentImage = currentSegmentImage + 1;
                } else {
                  //es igual
                  if (currentSegment !== 1) {
                    currentSegmentImage = 0;
                    currentSegment = currentSegment + 1;
                  } else {
                    currentSegmentImage = 0;
                    currentSegment = 0;
                  }
                }
              }, 3000);
            } else {
              console.log("ERROR: empty vars");
              return 0;
            }
          }
        } else {
          if (mainBgType === "Image") {
            if ($(window).width() > 767) {
              $("#mainHeroSlider").css(
                "background-image",
                "url('" + mainBgImageDesktop + "')"
              );
            } else {
              $("#mainHeroSlider").css(
                "background-image",
                "url('" + mainBgImageMobile + "')"
              );
            }
          } else if (mainBgType === "Video") {
            //to do
            //Video AJUSTAR CUANDO PODAMOS CARGAR VIDEOS AL ADMIN
            // if ($(window).width() > 767) {
            //
            // } else {
            //
            // }
            $("#mainHeroSlider").hide();
            $("#mainVideoSlider").show();
          } else {
            if ($(window).width() > 767) {
              if (mainBgImageDesktop) {
                $("#mainHeroSlider").css(
                  "background-image",
                  "url('" + mainBgImageDesktop + "')"
                );
              } else {
                if (mainBgVideoDesktop) {
                  $("#mainHeroSlider").hide();
                  $("#mainVideoSlider").show();
                }
              }
            } else {
              if (mainBgImageMobile) {
                $("#mainHeroSlider").css(
                  "background-image",
                  "url('" + mainBgImageMobile + "')"
                );
              } else {
                if (mainBgVideoMobile) {
                  $("#mainHeroSlider").hide();
                  $("#mainVideoSlider").show();
                }
              }
            }
          }
        }

        $("#mainHeroSlider").attr("title", mainBgAlt);

        ////////////////////////////////////////////
        ////////////////////////////////////////////

      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      },
    },


    single_blog:{
      init: function(){

        if ($(window).width() < 767) {
          const slider = $(".inner-itemss");

          slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            rtl: $('body').hasClass('rtl'),
            autoplaySpeed: 2000,
            arrow: false,
            infinite: false,
            speed: 300,
            // variableWidth: true,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  rtl: $('body').hasClass('rtl'),
                  variableWidth: false,
                  dots: true
                },
              },
            ],
          });
        }

      }
    },


    single_applications:{
      init: function(){
        const slider = $(".inner-itemss");

        slider.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          rtl: $('body').hasClass('rtl'),
          autoplaySpeed: 2000,
          arrow: false,
          infinite: false,
          speed: 300,
          // variableWidth: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                rtl: $('body').hasClass('rtl'),
                variableWidth: false,
                dots: true
              },
            },
          ],
        });
      }
    },

    page_template_ir_template: {
      init: function () {

        // Smooth scroll when clicking on nav items
        $(".ir-sections-item .ir-sections-item-link").click(function () {
          var anchor = $(this).attr("href");
          anchor = anchor.slice(1);

          $("html,body").animate(
            {
              scrollTop: $("#" + anchor).offset().top,
            },
            "slow"
          );
        });

      },
      finalize: function () {
        $(".ir-reports-more").click(function () {
          $(".ir-reports-more").hide();
          $(".loader-ir-reports").show();
          var htmlAppend = "";
          var counter = 1;
          reportsArray.forEach(function (e) {
            if (counter <= 3) {
              var reports = "";
              e.reports.forEach(function (r) {
                reports =
                  reports +
                  '<a href="' +
                  r.link["url"] +
                  '" class="item-link">' +
                  r.title +
                  '<span class="item-icon"></span></a>';
              });
              htmlAppend =
                htmlAppend +
                '<div class="ir-reports-item"><div class="item-top"><img class="item-img" src="' +
                e.icon +
                '" alt=""><div class="item-title">' +
                e.year +
                '</div> </div> <div class="item-bottom">' +
                reports +
                "</div> </div>";
              reportsArray = reportsArray.slice(1);
            } else {
              return false;
            }
            counter = counter + 1;
          });
          setTimeout(function () {
            $(".loader-ir-reports").hide();
            reportsArray.length ? $(".ir-reports-more").show() : $(".ir-reports-more").hide();
            $(".ir-reports-grid").append(htmlAppend);
          }, 1500);
        });
      },
    },

    page_template_news_events_template: {
      init: function () {




        const slider = $(".inner-itemss");

        slider.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          rtl: $('body').hasClass('rtl'),
          autoplaySpeed: 2000,
          arrow: false,
          infinite: false,
          speed: 300,
          dots: true,
          // variableWidth: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                dots: true,
                slidesToScroll: 1,
                rtl: $('body').hasClass('rtl'),
                variableWidth: false,
                vertical: true,
              },
            },
          ],
        });


        const sliderNews = $(".inner-itemsss");

        sliderNews.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          rtl: $('body').hasClass('rtl'),
          autoplaySpeed: 2000,
          arrow: false,
          infinite: false,
          speed: 300,
          dots: true,
          // variableWidth: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                dots: true,
                slidesToScroll: 1,
                rtl: $('body').hasClass('rtl'),
                variableWidth: false,
              },
            },
          ],
        });



        // JavaScript to be fired on Single Products Template,
        if ($('.event-slider .slick-track .item-event').length >= 3) {
          $('.event-slider .slick-track .item-event').last().find('.info-event').css({
            'left': 'unset',
            'right': '0'
          });
        }

      },
      finalize: function () {
        // JavaScript to be fired on the Single Products Template, after the init JS
      },
    },

    page_template_contact_us_template: {
      init: function () {
        // console.log("Contact Us started");

        setTimeout(function(){
          $(".hs-input").focus(function () {
            $(this).parent().prev().prev().addClass("input-active");
          });

          $(".hs-input").focusout(function () {
            if (!$(this).val()) {
              $(this).parent().prev().prev().removeClass("input-active");
            }
          });


          $(".wpcf7-form input, .wpcf7-form select, .wpcf7-form textarea").focus(function () {
            $(this).parent().prev().addClass("input-active");
          });

          $(".wpcf7-form input, .wpcf7-form select, .wpcf7-form textarea").focusout(function () {
            if (!$(this).val()) {
              $(this).parent().prev().removeClass("input-active");
            }
          });

          $(".wpcf7-form label").click(function () {
            $(this).addClass("input-active");
          });

        }, 1000);

        // $(document).ready(function(){
        //   $(".wpcf7-form select option:contains('---')").html('');
        //   setTimeout(function(){
        //     $("input[type=text],input[type=email],input[type=tel],select").attr('autocomplete', 'off').val('');
        //   }, 3000);
        // });

        // $("input[type=text],input[type=email],input[type=tel],select,textarea").val('');
        // $(".contact-us-template .hbspt-form .hs-form textarea").val('');
        // $(".contact-us-template .hbspt-form .hs-form textarea").html('');

        // Expand/contract accordion (offices, mobile)
        $(".item-button-title").click(function () {
          // console.log("click");
          if (!$(this).parent().parent().hasClass("offices-item-active")) {
            $(".offices-accordion .offices-item").removeClass(
              "offices-item-active"
            );
            $(this).parent().parent().addClass("offices-item-active");
          } else {
            $(this).parent().parent().removeClass("offices-item-active");
          }
        });

      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS

        setTimeout( function(){

        //   //Detect browser's user agent and add to HTML attribute.
        //   var doc = document.documentElement;
        //   doc.setAttribute('data-useragent', navigator.userAgent);

        //   // console.log('ok');

        //   //turn autocomplete off for forms on all browsers, except Chrome
        //   $('form').attr('autocomplete','off');
        //   $('input').attr('autocomplete','off');
        //   $('textarea').attr('autocomplete','off');

        //   $('form').attr('placeholder','');
        //   $('input').attr('placeholder','');
        //   $('textarea').attr('placeholder','');

        //   $('.contact-us-template .hbspt-form .hs-form textarea').attr('value','');
        //   $('.contact-us-template .hbspt-form .hs-form textarea').val('');
        //   $(".contact-us-template .hbspt-form .hs-form textarea").html('');

        //   //turn autocomplete off for forms for Chrome
        //   //based on a browser bug noted here: https://bugs.chromium.org/p/chromium/issues/detail?id=370363#c7
        //   $('html[data-useragent*="Chrome"] form').attr('autocomplete','false');
        //   $('html[data-useragent*="Chrome"] form input').attr('autocomplete','false');
        //   $('html[data-useragent*="Chrome"] form textarea').attr('autocomplete','false');

        //   $('html[data-useragent*="Chrome"] form').attr('placeholder','');
        //   $('html[data-useragent*="Chrome"] form input').attr('placeholder','');
        //   $('html[data-useragent*="Chrome"] form textarea').attr('placeholder','');

        //   $("input[type=text],input[type=email],input[type=tel],select,textarea").attr('autocomplete', 'off');
        //   $("input[type=text],input[type=email],input[type=tel],select,textarea").attr('placeholder', '');
        //   $("input[type=text],input[type=email],input[type=tel],select,textarea").val('');
        //   $("input[type=text],input[type=email],input[type=tel],select,textarea").html('');

        //   var bandera = true;

        //   $(".contact-form-container .hs-input").focus(function(){
        //     $(this).closest('.hs-form-field').find('label').addClass("input-active");
        //     $(this).keyup(function(){
        //       bandera = false;
        //     });
        //   }).blur(function(){

        //     if( !$(this).val() ) { //check to see if the input has a value
        //         $(this).closest('.hs-form-field').find('label').removeClass("input-active");
        //     } else {
        //       if (bandera){
        //         var thiss = $(this);
        //         setTimeout(function(){
        //           thiss.closest('.hs-form-field').find('label').removeClass("input-active");
        //           $("input[type=text],input[type=email],input[type=tel],select,textarea").attr('autocomplete', 'off');
        //           $("input[type=text],input[type=email],input[type=tel],select,textarea").attr('placeholder', '');
        //           $("input[type=text],input[type=email],input[type=tel],select,textarea").val('');
        //           $("input[type=text],input[type=email],input[type=tel],select,textarea").html('');
        //         },10);
        //       }
        //       $(this).closest('.hs-form-field').find('label').addClass("input-active");
        //     }
        //   });

        //   $(".contact-form-container .hs-input").on("change paste keyup", function() {
        //     if( !$(this).val() ) { //check to see if the input has a value
        //       $(this).closest('.hs-form-field').find('label').removeClass("input-active");
        //     }
        //   });

          //custom checkbox
          if ( $(".hbspt-form form fieldset .hs-form-booleancheckbox-display .checkmark").length == 0){
            $(".hbspt-form form fieldset .hs-form-booleancheckbox-display").append('<span class="checkmark"></span>');
          }

        },1000);

      },
    },

    // Human Resources Template / HR
    page_template_human_resources_template: {
      init: function () {
        $(".hero-slider").slick({
          autoplay: true,
          autoplaySpeed: 3000,
          dots: true,
          fade: true,
          cssEase: "linear",
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          rtl: $('body').hasClass('rtl'),
        });


        //Detect browser's user agent and add to HTML attribute.
        var doc = document.documentElement;
        doc.setAttribute('data-useragent', navigator.userAgent);



        $(".open-form").click(function () {

          $(".hr-application-container").addClass("form-visible");
          $(".hr-application-container").css("overflow-y", "scroll");
          $(".hr-application-container .hr-form").css({
            "margin-top": "60px",
            "margin-bottom": "60px"
          });

          $('body').addClass('hiddenOverflow');


          $('.hr-application-container.form-visible').on('click', function(e){
            // console.log(e.target.nodeName);
            // console.log(e.target.className);

            if ( e.target.className === "hr-application-container form-visible"){
              $('.hr-application-container').removeClass("form-visible");
              $('body').removeClass('hiddenOverflow');
            }

          });

          $(document).ready( function(){

              //turn autocomplete off for forms on all browsers, except Chrome
              $('form').attr('autocomplete','off');
              $('input').attr('autocomplete','off');
              $('textarea').attr('autocomplete','off');

              $('form').attr('placeholder','');
              $('input').attr('placeholder','');
              $('textarea').attr('placeholder','');

              //turn autocomplete off for forms for Chrome
              //based on a browser bug noted here: https://bugs.chromium.org/p/chromium/issues/detail?id=370363#c7
              $('html[data-useragent*="Chrome"] form').attr('autocomplete','false');
              $('html[data-useragent*="Chrome"] form input').attr('autocomplete','false');
              $('html[data-useragent*="Chrome"] form textarea').attr('autocomplete','false');

              $('html[data-useragent*="Chrome"] form').attr('placeholder','');
              $('html[data-useragent*="Chrome"] form input').attr('placeholder','');
              $('html[data-useragent*="Chrome"] form textarea').attr('placeholder','');

              $("input[type=text],input[type=email],input[type=tel],select,textarea").attr('autocomplete', 'off').val('');
              $("input[type=text],input[type=email],input[type=tel],select,textarea").attr('placeholder', '');

              $(".contact-form-container .hs-input").focus(function(){
                $(this).closest('.hs-form-field').find('label').addClass("input-active");
              }).blur(function(){
                if( !$(this).val() ) { //check to see if the input has a value
                  $(this).closest('.hs-form-field').find('label').removeClass("input-active");
                } else {
                  $(this).closest('.hs-form-field').find('label').addClass("input-active");
                }
              });

              $(".contact-form-container .hs-input").on("change paste keyup", function() {
                if( !$(this).val() ) { //check to see if the input has a value
                  $(this).closest('.hs-form-field').find('label').removeClass("input-active");
                }
              });


              //on focus form input
              $( ".hr-application-container .hbspt-form form input[type='text'], " +
                ".hr-application-container .hbspt-form form input[type='email'], " +
                ".hr-application-container .hbspt-form form input[type='tel']" ).on('focus', function () {
                $(this).closest('.hs-form-field').find('label').addClass("input-active");
              });

              //on blur form input
              $( ".hr-application-container .hbspt-form form input[type='text'], " +
                ".hr-application-container .hbspt-form form input[type='email'], " +
                ".hr-application-container .hbspt-form form input[type='tel']" ).on('blur', function () {
                if (!$(this).val()) {
                  $(this).closest('.hs-form-field').find('label').removeClass("input-active");
                }
              });

              //custom file button
              if ( $(".hr-application-container .hbspt-form form fieldset .hs-file > label .button-icon").length == 0){
                $(".hr-application-container .hbspt-form form fieldset .hs-file > label").prepend('<span class="button-icon"></span>');
              }
              if ( $(".hr-application-container .hbspt-form form fieldset .hs-file > label .button-arrow").length == 0){
                $(".hr-application-container .hbspt-form form fieldset .hs-file > label").append('<span class="button-arrow"></span>');
              }
              if ( $(".hr-application-container .hbspt-form form fieldset .hs-file .file-name").length == 0){
                $(".hr-application-container .hbspt-form form fieldset .hs-file").append('<span class="file-name"></span>');
              }

              $(".hr-application-container .hbspt-form form fieldset .hs-file input[type='file']").change(function(e){
                if ( e.target.files.length ){
                  var fileName = e.target.files[0].name;
                  // console.log(e.target.files);
                }else{
                  fileName = "";
                }

                $(".hr-application-container .hbspt-form form fieldset .hs-file .file-name").html(fileName);
              });

              //custom checkbox
              if ( $(".hr-application-container .hbspt-form form fieldset .hs-form-booleancheckbox-display .checkmark").length == 0){
                $(".hr-application-container .hbspt-form form fieldset .hs-form-booleancheckbox-display").append('<span class="checkmark"></span>');
              }

          });

        });


        $(".form-close").click(function () {
          $(".hr-application-container").removeClass("form-visible");
          $('body').removeClass('hiddenOverflow');
        });

        $("#formFirstName, #formLastName, #formEmail, #formPhone").focus(
          function () {
            $(this).next().addClass("input-active");
          }
        );

        $("#formFirstName, #formLastName, #formEmail, #formPhone").focusout(
          function () {
            if (!$(this).val()) {
              $(this).next().removeClass("input-active");
            }
          }
        );

        // Smooth scroll when clicking on nav items
        $(".hr-nav .hr-nav-item a").click(function () {
          var anchor = $(this).attr("href");
          anchor = anchor.slice(1);

          $("html,body").animate(
            {
              scrollTop: $("#" + anchor).offset().top,
            },
            "slow"
          );
        });

        // Highlight nav items when scrolling through their sections
        var screenHeight = screen.height;
        screenHeight /= 2;
        $(".hr-nav .hr-nav-item a").on("click", function (event) {
          $(this).parent().parent().find("a").removeClass("item-active");
          $(this).parent().addClass("item-active");
        });
        $(window).on("scroll", function () {
          $(".target-anchor").each(function () {
            if ($(window).scrollTop() >= $(this).offset().top - screenHeight) {
              var id = $(this).attr("id");
              $(".hr-nav .hr-nav-item a").parent().removeClass("item-active");
              $(".hr-nav .hr-nav-item a[href=#" + id + "]")
                .parent()
                .addClass("item-active");
            }
          });
        });

        $(".hr-find .positions-item a.link-acc").on("click", function () {
          $(this).toggleClass('active');
        });

        // "Find" section: show position details and hide
        // other positions
        var flagBool = false;
        $(".hr-find .positions-item .item-close").on("click", function () {

           //
           // var element = $(this);
           //  $("html, body").animate(
           //    {
           //      scrollTop: jQuery(element).offset().top - 200,
           //    },
           //    1500
           //  );//



          if(!flagBool){
            $(this).parent().parent().parent().addClass("fix-img");
          }else{
            $(this).parent().parent().parent().removeClass("fix-img");
          }
          flagBool = !flagBool
        });



        /////////////////////////////////////
        //////////FIX HR SLIDER MEET/////////
        /////////////////////////////////////
        var sliderSolutionWindowWidth = $(window).width();
        var sliderSolutionSliderWidth = $(".hr-meet").width();
        var sliderSolutionWidthFixed =
          (sliderSolutionWindowWidth - sliderSolutionSliderWidth) / 2;
        $(".people-slider, .vibe-slider").css({
          width: "calc(100% + " + sliderSolutionWidthFixed + "px ",
        });

        /////////////////////////////////////
        /////////////////////////////////////
        /////////////////////////////////////

        // Meet team slider
        // $(".people-slider").slick({
        //   slidesToShow: 2,
        //   infinite: false,
        //   responsive: [
        //     {
        //       breakpoint: 520,
        //       settings: {
        //         slidesToShow: 1,
        //       },
        //     },
        //   ],
        // });

        // Adds mouse wheel scrolling to slider
        // $(".people-slider").on("wheel", function (e) {
        //   e.preventDefault();
        //   if (e.originalEvent.deltaY < 0) {
        //     $(this).slick("slickPrev");
        //   } else {
        //     $(this).slick("slickNext");
        //   }
        // });

        // Amiad vibe section slider
        // $(".vibe-slider").slick({
        //   slidesToShow: 3,
        //   infinite: false,
        //   responsive: [
        //     {
        //       breakpoint: 520,
        //       settings: {
        //         slidesToShow: 2,
        //       },
        //     },
        //   ],
        // });
        $('.vibe-slider').niceScroll({
            cursorcolor: '#d33138',
            autohidemode: false,
            enablemousewheel: false,
            cursorwidth: "7px",
            background: "#c3c5c6",
            cursorborder: "none",
            cursorborderradius: "0px"
        });

        // Adds mouse wheel scrolling to slider
        // $(".vibe-slider").on("wheel", function (e) {
        //   e.preventDefault();
        //   if (e.originalEvent.deltaY < 0) {
        //     $(this).slick("slickPrev");
        //   } else {
        //     $(this).slick("slickNext");
        //   }
        // });


        $('.clip-play-icon').click(function(){
          var openVideo = $(this).data('videoimg');
          $('.inner-modal-clip .video-modal').each(function(e){
            if(openVideo == e){
              $(this).css({'display': 'block'})
            }
          })
        });

      $('.ico-close-clip').click(function(){
        var aux = $('.inner-modal-clip').html();
        $('.inner-modal-clip').html(' ')
        $('.inner-modal-clip').html(aux)
        $('.inner-modal-clip .video-modal').each(function(e){
          $('[data-videomod]').each(function(){
            $(this).css({'display': 'none'})
          })
        })
      })


        if ($(window).width() < 767) {
          const slider = $(".inner-itemss");
          slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            rtl: $('body').hasClass('rtl'),
            autoplaySpeed: 2000,
            arrow: false,
            infinite: false,
            speed: 300,
            // variableWidth: true,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  rtl: $('body').hasClass('rtl'),
                  variableWidth: false,
                  dots: true
                },
              },
            ],
          });
        }




      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
        $(".hr-application-container .hbspt-form form fieldset .hs-input").not(':input[type=button]').blur();
      },
    },

    // Single Products
    single_products: {
      init: function () {


        if ($(window).width() < 767) {
          const slider = $(".inner-itemss");

          slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            rtl: $('body').hasClass('rtl'),
            autoplaySpeed: 2000,
            arrow: false,
            infinite: false,
            speed: 300,
            // variableWidth: true,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  rtl: $('body').hasClass('rtl'),
                  variableWidth: false,
                  dots: true
                },
              },
            ],
          });
        }



        var modal = $('.modal-gallery');

        var auxCounter = 0;
        var spanTitle = 0;

        $(document).click(function(event) {
          if (event.target == modal[0]) {
            auxCounter = 0;
            spanTitle = 0;
            $('.modal-gallery').css({'display': 'none'});
            fixModalGallery();
          }
        });



        function fixModalGallery(){
          // $('.modal-gallery .inner-modal-clip .img-gallery').css({'display': 'none'});
          // $($('.modal-gallery .inner-modal-clip .img-gallery')[auxCounter]).css({'display': 'block'});

          $('.modal-gallery .inner-modal-clip .img-gallery').fadeOut("slow");
          $($('.modal-gallery .inner-modal-clip .img-gallery')[auxCounter]).fadeIn("slow");

        }
        function fixModalTitle(){
          $('.modal-gallery .inner-modal-clip .title-clip .span-title-gallery').css({'display': 'none'});
          $($('.modal-gallery .inner-modal-clip .title-clip .span-title-gallery')[spanTitle]).css({'display': 'block'});
        }

        $('.modal-gallery .ico-close-clip').click(function(){
          auxCounter = 0;
          spanTitle = 0;
          $('.modal-gallery').css({'display': 'none'});
          fixModalGallery();
          fixModalTitle();
        });

        $('#opengallerymodal').click(function(e){
          auxCounter = 0;
          spanTitle = 0;
          e.preventDefault();
          $('.modal-gallery').css({'display': 'flex'});
          fixModalGallery();
          fixModalTitle();
        });

        $('.left-arrow-modal').click(function(){
          if(auxCounter > 0){
            auxCounter = auxCounter - 1;
            spanTitle = spanTitle - 1;
            fixModalGallery();
            fixModalTitle();
          }
        });

        $('.right-arrow-modal').click(function(){
          if(auxCounter >= 0 && auxCounter < ($($('.modal-gallery .inner-modal-clip .img-gallery')).length - 1)) {
            auxCounter = auxCounter + 1
            spanTitle = spanTitle + 1;
            fixModalGallery();
            fixModalTitle();
          }
        });

        // JavaScript to be fired on Single Products Template

        /* Download Section */

        /* ***********************************************************************
         *   CLOSE ICON
         * ********************************************************************* */
        $(".download-section .close-icon").on("click", function () {
          $(".download-section .show-less").removeClass("active");
          $(".download-section .show-more").addClass("active");
          $(".download-section .download-area").removeClass("active");
          $(".download-section .watch-area").removeClass("active");
          $(".download-section .see-area").removeClass("active");

          $(".download-section .download-area").css("display", "block");
          $(".download-section .watch-area").css("display", "block");
          $(".download-section .see-area").css("display", "block");

          $(".download-section").css("box-shadow", "none");

          $(this).toggleClass("active");
        });

        /* ***********************************************************************
         *   DOWNLOAD AREA
         * ********************************************************************* */
        $(".download-section .download-area .show-more").on(
          "click",
          function () {
            $(this).toggleClass("active");
            $(this).parent().find(".show-less").toggleClass("active");
            $(".download-section .close-icon").toggleClass("active");
            $(this).parent().toggleClass("active");

            $(".download-section").css(
              "box-shadow",
              "0px 10px 25px rgba(0,0,0,0.5)"
            );

            $(this)
              .closest(".inner")
              .find(".watch-area")
              .css("display", "none");
            $(this).closest(".inner").find(".see-area").css("display", "none");
          }
        );

        $(".download-section .download-area .show-less").on(
          "click",
          function () {
            $(this).toggleClass("active");
            $(this).parent().find(".show-more").toggleClass("active");
            $(".download-section .close-icon").toggleClass("active");
            $(this).parent().toggleClass("active");

            $(".download-section").css("box-shadow", "none");

            $(this)
              .closest(".inner")
              .find(".watch-area")
              .css("display", "block");
            $(this).closest(".inner").find(".see-area").css("display", "block");
          }
        );

        /* ***********************************************************************
         *   WATCH AREA
         * ********************************************************************* */
        $(".download-section .watch-area .show-more").on("click", function () {
          $(this).toggleClass("active");
          $(this).parent().find(".show-less").toggleClass("active");
          $(".download-section .close-icon").toggleClass("active");
          $(this).parent().toggleClass("active");

          $(".download-section").css(
            "box-shadow",
            "0px 10px 25px rgba(0,0,0,0.5)"
          );

          $(this)
            .closest(".inner")
            .find(".download-area")
            .css("display", "none");
          $(this).closest(".inner").find(".see-area").css("display", "none");
        });

        $(".download-section .watch-area .show-less").on("click", function () {
          $(this).toggleClass("active");
          $(this).parent().find(".show-more").toggleClass("active");
          $(".download-section .close-icon").toggleClass("active");
          $(this).parent().toggleClass("active");

          $(".download-section").css("box-shadow", "none");

          $(this)
            .closest(".inner")
            .find(".download-area")
            .css("display", "block");
          $(this).closest(".inner").find(".see-area").css("display", "block");
        });

        /* ***********************************************************************
         *   SEE AREA
         * ********************************************************************* */
        $(".download-section .see-area .show-more").on("click", function () {
          $(this).toggleClass("active");
          $(this).parent().find(".show-less").toggleClass("active");
          $(".download-section .close-icon").toggleClass("active");
          $(this).parent().toggleClass("active");

          $(".download-section").css(
            "box-shadow",
            "0px 10px 25px rgba(0,0,0,0.5)"
          );

          $(this)
            .closest(".inner")
            .find(".download-area")
            .css("display", "none");
          $(this).closest(".inner").find(".watch-area").css("display", "none");
        });

        $(".download-section .see-area .show-less").on("click", function () {
          $(this).toggleClass("active");
          $(this).parent().find(".show-more").toggleClass("active");
          $(".download-section .close-icon").toggleClass("active");
          $(this).parent().toggleClass("active");

          $(".download-section").css("box-shadow", "none");

          $(this)
            .closest(".inner")
            .find(".download-area")
            .css("display", "block");
          $(this).closest(".inner").find(".watch-area").css("display", "block");
        });


        /* FUNCIONALIDAD DE LOS MODALES EN */
        $(".download-section .watch-area .files-container .li-modal").click(function (e) {
          e.preventDefault();

          var iframeModal = $(this).find('iframe');
          var liModal = $(this);

          $(".modal-clip .inner-modal-clip .modal-clip-iframe").append(iframeModal);

          $(".modal-clip").css("display", "flex");
          $("body").css("overflow-y", "hidden");

          $(".modal-clip").click(function () {
            $(this).css("display", "none");
            liModal.append(iframeModal);
            $(".modal-clip .inner-modal-clip .modal-clip-iframe").empty();

            $(".yvideo").each(function () {
              $(this).attr("src", $(this).attr("src"));
              return false;
            });
            $("body").css("overflow-y", "scroll");
          });

        });


      },
      finalize: function () {
        // JavaScript to be fired on the Single Products Template, after the init JS
      },
    },

    // Single Studies
    single_studies: {
      init: function () {
        // JavaScript to be fired on Single Products Template}

        //////////////////////////////////////////////
        //SLIDERS SCRIPTS ON SINGLE STUDIES //////////
        $(".background-slider").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          rtl: $('body').hasClass('rtl'),
          autoplaySpeed: 2000,
          arrows: false,
          dots: true,
          infinite: true,
          speed: 500,
          centerMode: true,
          variableWidth: true,
        });

        $(".background-slider .slick-dots").css(
          "width",
          $(document).width() - $(".background-slider").offset().left
        );

        $(window).resize(function () {
          $(".background-slider .slick-dots").css(
            "width",
            $(document).width() - $(".background-slider").offset().left
          );
        });



        const slider = $(".inner-itemss");

        slider.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          rtl: $('body').hasClass('rtl'),
          autoplaySpeed: 2000,
          arrow: false,
          infinite: false,
          speed: 300,
          // variableWidth: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                rtl: $('body').hasClass('rtl'),
                variableWidth: false,
                dots: true
              },
            },
          ],
        });


      },
      finalize: function () {
        // JavaScript to be fired on the Single Products Template, after the init JS
      },
    },

    // Single Technology Template
    single_technology: {
      init: function () {
        // JavaScript to be fired on Single Products Template}
        if ($(window).width() < 767) {
          const slider = $(".inner-itemss");
          slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            rtl: $('body').hasClass('rtl'),
            autoplaySpeed: 2000,
            arrow: false,
            infinite: false,
            speed: 300,
            // variableWidth: true,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  rtl: $('body').hasClass('rtl'),
                  variableWidth: false,
                  dots: true
                },
              },
            ],
          });
        }
      },
      finalize: function () {
        // JavaScript to be fired on the Single Products Template, after the init JS

        // ********************************
        // relevant products (START)
        // ********************************
        const slider_relevant_products = $(
          ".relevant-products.slider .inner-items"
        );

        slider_relevant_products.slick("unslick");
        slider_relevant_products.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          rtl: $('body').hasClass('rtl'),
          autoplaySpeed: 2000,
          arrow: false,
          infinite: false,
          speed: 300,
          // variableWidth: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                rtl: $('body').hasClass('rtl'),
                variableWidth: false,
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                rtl: $('body').hasClass('rtl'),
                variableWidth: false,
              },
            },
          ],
        });

        // Adds mouse wheel scrolling to slider
        // slider_relevant_products.on("wheel", function (e) {
        //   e.preventDefault();

        //   if (e.originalEvent.deltaY > 0) {
        //     $(this).slick("slickNext");
        //   } else {
        //     $(this).slick("slickPrev");
        //   }
        // });

        // ********************************
        // relevant products (END)
        // ********************************

        // ********************************
        // additional technologies (START)
        // ********************************

        //additional technologies STYLES
        function additional_technologies() {
          var blockElements = $(".additional-technologies .list .block");
          var listBlockElements = blockElements.parent();
          var blockElements_top = $(
            ".additional-technologies .list .block .top"
          );
          var blockElements_botom = $(
            ".additional-technologies .list .block .top"
          );
          var blockElements_icon = $(
            ".additional-technologies .list .block .top .icon-image"
          );
          var blockElements_img = $(
            ".additional-technologies .list .block .bottom .block-image"
          );

          switch (blockElements.length) {
            case 4: {
              blockElements.css({
                width: "24%",
                "margin-right": "1.3%",
              });
              blockElements_icon.css({
                bottom: "5%",
                right: "5%",
                "max-width": "50px",
              });
              blockElements_top.css({
                height: "160px",
              });
              break;
            }
            case 3: {
              blockElements.css("width", "32%");
              blockElements_icon.css({
                bottom: "8%",
                right: "5%",
                "max-width": "75px",
              });
              break;
            }
            case 2: {
              blockElements.css("width", "49%");
              blockElements_icon.css({
                bottom: "8%",
                right: "5%",
                "max-width": "75px",
              });
              break;
            }
            case 1: {
              blockElements.css();
              blockElements_icon.css({
                bottom: "5%",
                right: "5%",
                "max-width": "50px",
              });
              break;
            }
          }
        }

        //additional technologies SLIDER
        function additional_technologies_slider() {
          if (
            !$(".additional-technologies .list").hasClass("slick-initialized")
          ) {
            $(".additional-technologies .list").slick({
              dots: false,
              prevArrow: false,
              nextArrow: false,
              centerMode: true,
              centerPadding: '2px',
              infinite: true,
              // variableWidth: true,
              slidesToScroll: 1,
              rtl: $('body').hasClass('rtl'),
            });
          }
        }

        if ($(window).width() <= 1400) {
          additional_technologies();
        }

        if ($(window).width() <= 992) {
          additional_technologies_slider();
        }

        $(window).resize(function () {
          if ($(window).width() < 1400) {
            additional_technologies();
          }

          if ($(window).width() <= 992) {
            additional_technologies_slider();
          }
        });

        // ********************************
        // additional technologies (END)
        // ********************************
      },
    },

    // Textual Page
    page_template_textual_template: {
      init: function () {
        // JavaScript to be fired on Single Products Template}
      },
      finalize: function () {
        // JavaScript to be fired on the Single Products Template, after the init JS

        //additional content SLIDER
        function relevant_post_slider() {
          if (
            !$(".relevant-post .container-items .box-items").hasClass(
              "slick-initialized"
            )
          ) {
            $(".relevant-post .container-items .box-items").slick({
              dots: false,
              prevArrow: false,
              nextArrow: false,
              infinite: false,
              centerMode: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              rtl: $('body').hasClass('rtl'),
            });
          }
        }

        if ($(window).width() <= 767) {
          relevant_post_slider();
        }

        $(window).resize(function () {
          if ($(window).width() <= 767) {
            relevant_post_slider();
          }
        });
      },
    },

    // Segmante Template
    page_template_segment_template: {
      init: function () {
        // JavaScript to be fired on Single Products Template

        //SLIDERS SCRIPTS//////////
        if ($(window).width() < 767) {
          const slider = $(".inner-itemss");
          slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            rtl: $('body').hasClass('rtl'),
            autoplaySpeed: 2000,
            arrow: false,
            infinite: false,
            speed: 300,
            // variableWidth: true,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  rtl: $('body').hasClass('rtl'),
                  variableWidth: false,
                  dots: true
                },
              },
            ],
          });
        }


      },
      finalize: function () {
        // JavaScript to be fired on the Single Products Template, after the init JS

        // ********************************
        // relevant products (START)
        // ********************************
        const slider_relevant_products = $(
          ".relevant-products.slider .inner-items"
        );

        slider_relevant_products.slick("unslick");
        slider_relevant_products.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          rtl: $('body').hasClass('rtl'),
          autoplaySpeed: 2000,
          arrow: true,
          infinite: false,
          speed: 300,
          // variableWidth: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                rtl: $('body').hasClass('rtl'),
                variableWidth: false,
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                rtl: $('body').hasClass('rtl'),
                variableWidth: false,
              },
            },
          ],
        });

        // Adds mouse wheel scrolling to slider
        // slider_relevant_products.on("wheel", function (e) {
        //   e.preventDefault();

        //   if (e.originalEvent.deltaY > 0) {
        //     $(this).slick("slickNext");
        //   } else {
        //     $(this).slick("slickPrev");
        //   }
        // });
      },
    },

    // Directors Template
    page_template_directors_template: {
      init: function () {
        // JavaScript to be fired on Single Products Template
      },
      finalize: function () {
        // JavaScript to be fired on the Single Products Template, after the init JS

        $(".members .inner .member-box .read-more").on("click", function (e) {
          e.preventDefault();

          $(".members .inner .member-box").css("opacity", "0.2");

          var target = $(this).data("target");

          //member-box selected
          var member = $('[data-member="' + target + '"]');

          //member-box selected attributes
          var first_member_img = $(
            '[data-member="member-modal-1"] .member-img'
          );


          var member_img = $('[data-member="' + target + '"] .member-img');
          var member_name = $('[data-member="' + target + '"] .member-name');
          var member_position = $(
            '[data-member="' + target + '"] .member-position'
          );
          var member_divider = $('[data-member="' + target + '"] .divider');
          var member_description = $(
            '[data-member="' + target + '"] .member-description'
          );
          var member_read_more = $('[data-member="' + target + '"] .read-more');

          var leftPadding = parseInt($(".members .inner").css("padding-left"));

          var imgLeftPosition = member_img.position().left - leftPadding;
          var leftPosition = first_member_img.position().left - leftPadding;

          var topPosition = member_img.position().top;
          var imgWidth = parseInt(member_img.css("width"));

          var memberModal = "#" + $(this).data("target");


          var fixpositionwidth = $(this).data('fixpositionwidth');
          var memberid = $(this).data("memberid");
          var fixposition = $(this).data("fixposition");




          $(document).on("click", function (e) {
            if ($(e.target).find(".inner-content-modal").length) {
              $(memberModal).find(".read-less").click();
            }
          });

          // member_img.css("opacity", "0.1");
          // member_name.css("opacity", "0.1");
          // member_position.css("opacity", "0.1");
          // member_divider.css("opacity", "0.1");
          // member_description.css("opacity", "0.1");
          // member_read_more.css("opacity", "0.1");

          setTimeout(function () {
            $(memberModal).css("display", "flex");
            $(memberModal).css("opacity", "1");

            $(memberModal).find(".content").css("padding-left", leftPosition);
            $(memberModal).find(".content").css("margin-top", topPosition);

            // $(memberModal)
            //   .find(".content .member-img")
            //   .css("margin-left", imgLeftPosition - leftPosition);
            $(memberModal).find(".content .member-img").css("width", imgWidth);
            var modalDescriptionHeight = $(memberModal)
              .find(".content .member-description")
              .innerHeight();

            $(".members .inner").css(
              "padding-bottom",
              modalDescriptionHeight - 200
            );

            // $(memberModal)
            //   .find(".close-icon")
            //   .css("left", imgWidth + 25);
            //   console.log("Img Left: ", imgLeftPosition);
            //   console.log("Left: ", leftPosition);
            //   console.log("width: ", imgWidth);
            //   console.log("total: ", imgLeftPosition - leftPosition + imgWidth + 25);

            // $(memberModal).find(".close-icon").css("right", "unset");

            $(memberModal)
              .find(".content .member-position")
              .css("width", member_position.css("width"));

            if ($(window).width() <= 475) {
              $(memberModal).find(".close-icon").css("left", "unset");
              $(memberModal).find(".close-icon").css("right", "45px");
              $(memberModal).find(".close-icon").css("top", "-40px");
            }
          }, 50);

          function closeMemberModal(e) {
            e.preventDefault();
            $(memberModal).css("display", "none");
            $(".members .inner .member-box").css("opacity", "1");
            $(".members .inner").css("padding-bottom", "50px");

            member_img.css("opacity", "1");
            member_name.css("opacity", "1");
            member_position.css("opacity", "1");
            member_divider.css("opacity", "1");
            member_description.css("opacity", "1");
            member_read_more.css("opacity", "1");
          }

          if($(window).width() > 1439){

            if (fixposition) {
              //harcoded numbers for member image of 250px width
              if(fixpositionwidth == 66.6) {
                $(memberModal + ' .inner-content-modal').css({
                  'width': '63.2%',
                  'display': 'flex',
                  'flex-direction': 'column',
                  'margin-left': 'auto'
                });
                $(memberModal + ' .fix-content-modal').css({
                  // 'width': '63%',
                  // 'margin-left': 'auto',
                  'padding-right': '100px'
                });
              }
              if(fixpositionwidth === 33.3){
                $(memberModal + ' .inner-content-modal').css({
                  'width': '63.2%',
                  'display': 'flex',
                  'flex-direction': 'column',
                  'margin-left': 'auto'
                });
                $(memberModal)
                  .find(".content .member-img")
                  .css({
                    'margin-left': 'auto',
                    'margin-right': '100px',
                  });
                $(memberModal + ' .fix-content-modal').css({
                  // 'width': '64%',
                  // 'text-align': 'right',
                  // 'margin-left': 'auto',
                  'margin-right': '100px',
                  // 'padding-left': '100px'
                });
                $(memberModal + ' .fix-member-details').css({
                  'width': '250px',
                  'margin-left': 'auto'
                });
                // $(memberModal + ' .member-description').css({
                  // 'text-align': 'right'
                // });

              }
                $(memberModal + ' .read-less').css({
                  'display': 'block',
                  'position': 'relative',
                  'top': '-15px',
                  'margin-right': '15px'
                });
            }


            var $pos = $(memberModal).data('m-d');
            $(memberModal + ' .close-icon').css({
                "left": (parseInt($pos) === 3 ? 'unset' : '275px'),
                "right": (parseInt($pos) === 3 ? '50px' : 'unset'),
              });

          } else if($(window).width() <= 1024){

            $(memberModal + ' .inner-content-modal').css({
                'width': '100%',
                'display': 'flex',
                'flex-direction': 'column',
                'margin-left': 'auto'
              });

              var $pos = $(memberModal).data('m-t');

              if ($pos === 1) {
                $(memberModal)
                  .find(".content .member-img")
                  .css({
                    'margin-left': '0px',
                    'margin-right': '100px',
                  });
                  $(memberModal + ' .fix-member-details').css({
                    'width': '250px',
                    'margin-left': '0px',
                  });
              } else {
                $(memberModal)
                  .find(".content .member-img")
                  .css({
                    'margin-left': 'auto',
                    'margin-right': '100px',
                  });
                  $(memberModal + ' .fix-member-details').css({
                    'width': '250px',
                    'margin-left': 'auto'
                  });
              }

              $(memberModal + ' .fix-content-modal').css({
                'margin-right': '100px',
              });

              $(memberModal + ' .read-less').css({
                'display': 'block'
              });
              $(memberModal)
                .find(".close-icon")
                .css("left", ($pos === 1 ? '275px' : '750px'));
          } else if($(window).width() < 768){

            $(memberModal + ' .inner-content-modal').css({
                'width': '100%',
                'display': 'flex',
                'flex-direction': 'column',
                'margin-left': 'auto'
              });

              $(memberModal)
                .find(".content .member-img")
                .css({
                  'margin-left': '0px',
                  'margin-right': '100px',
                  'max-height': 'unset',
                });
              $(memberModal + ' .fix-content-modal').css({
                'margin-right': '30px',
              });
              $(memberModal + ' .fix-member-details').css({
                'width': '250px',
                'margin-left': '0px',
              });
              $(memberModal + ' .read-less').css({
                'display': 'block'
              });
              $(memberModal)
                .find(".close-icon")
                .css("left", ($pos === 1 ? '275px' : '750px'));
          }

          $(memberModal)
            .find(".read-less")
            .on("click", function (e) {
              closeMemberModal(e);
            });

          $(memberModal)
            .find(".close-icon")
            .on("click", function (e) {
              closeMemberModal(e);
            });
        });
      },
    },

    // List Template
    page_template_list_template: {
      init: function () {
        // JavaScript to be fired on Single Products Template
        // $(document).ready(function () {
        //
        //   $(".submenu-list").css("display", "none");
        //   $('ul li').click(function () {
        //     $('ul li ul').slideUp();
        //     $(this).children('ul').slideDown();
        //   });
        //
        //   // $('ul li ul li').click(function (e) {
        //   //   var newText = $(this).text();
        //   //   $(this).parents('li').find('span').text(newText);
        //   //   e.stopPropagation();
        //   // });
        // });


        $(".container-items li.has_submenu").on("click", function (e) {
          // e.preventDefault();
          $(this).toggleClass("active");
        });

      },

      finalize: function () {
        // JavaScript to be fired on the Single Products Template, after the init JS
      },
    },

    page_template_download_template: {
      init: function () {
        $("form .tml-email-wrap input, form .tml-name-wrap input")
          .focus(function () {
            $(this).prev("label").addClass("active");
          })
          .blur(function () {
            if (!$(this).val()) {
              $(this).prev("label").removeClass("active");
            }
          });
      }
    },

    // Login Template
    page_template_login_template: {
      init: function () {
        // JavaScript to be fired on Single Products Template

        $(".tml-login form .tml-log-wrap input, .tml-login form .tml-pwd-wrap input")
          .focus(function () {
            $(this).prev("label").addClass("active");
          })
          .blur(function () {
            if (!$(this).val()) {
              $(this).prev("label").removeClass("active");
            }
          });

        $('.login-template .border-top-bottom .container .login-form-container .login-title span').remove();
        $('.login-template .border-top-bottom .container .login-form-container .tml-login .tml-links .tml-lostpassword-link').remove();

      },
      finalize: function () {
        // JavaScript to be fired on the Single Products Template, after the init JS

        $(
          ".tml-login form .tml-log-wrap input, .tml-login form .tml-pwd-wrap input"
        ).blur();
      },
    },

    // Login Template
    page_template_lostpassword_template: {
      init: function () {
        // JavaScript to be fired on Single Products Template

        $(".tml-lostpassword form .tml-user_login-wrap input")
          .focus(function () {
            $(this).prev("label").addClass("active");
          })
          .blur(function () {
            if (!$(this).val()) {
              $(this).prev("label").removeClass("active");
            }
          });
      },
      finalize: function () {
        // JavaScript to be fired on the Single Products Template, after the init JS
      },
    },

    // Register Template
    page_template_register_template: {
      init: function () {
        // JavaScript to be fired on Single Products Template

        $(document).ready(function () {
          $("#user_country").css("color", "#575756");
          $("#user_segment").css("color", "#575756");

          function checkSelect(field) {
            if (field.find(":selected").text() === "") {
              field.prev("label").removeClass("active");
              setTimeout(function () {
                field
                  .next("label.user-registration-error")
                  .css("display", "block");
              }, 200);
            } else {
              field.prev("label").addClass("active");
              setTimeout(function () {
                field
                  .next("label.user-registration-error")
                  .css("display", "none");
              }, 200);
            }
          }

          function checkFocusFields(field) {
            field.focus(function () {
              var $this = $(this);

              $this.prev("label").addClass("active");

              setTimeout(function () {
                $this
                  .next("label.user-registration-error")
                  .css("display", "none");
              }, 200);
            });
            field.blur(function () {
              var $this = $(this);

              if (!$this.val() || $this.val() === "") {
                $this.prev("label").removeClass("active");
                setTimeout(function () {
                  $this
                    .next("label.user-registration-error")
                    .css("display", "block");
                }, 200);
              }
            });
          }

          //for input elements and select fields
          checkFocusFields($(".ur-field-item input"));
          checkFocusFields($(".ur-field-item select"));

          //for password field
          $(".ur-field-item span input")
            .focus(function () {
              $(this).parent().parent().find("label").addClass("active");

              setTimeout(function () {
                $(this)
                  .parent()
                  .parent()
                  .next("label.user-registration-error")
                  .css("display", "none");
              }, 200);
            })
            .blur(function () {
              if (!$(this).val()) {
                $(this).parent().parent().find("label").removeClass("active");

                setTimeout(function () {
                  $(this)
                    .parent()
                    .parent()
                    .next("label.user-registration-error")
                    .css("display", "block");
                }, 200);
              }
            });

          $("form.register").submit(function (e) {
            e.preventDefault();
            e.stopPropagation();

            $(document).click();

            checkSelect($("#user_country"));
            checkSelect($("#user_segment"));

            $(this).submit();
          });

          $(document).on({
            click: function () {
              checkSelect($("#user_country"));
              checkSelect($("#user_segment"));
            },
            change: function () {
              checkSelect($("#user_country"));
              checkSelect($("#user_segment"));
            },
          });
        });
      },
      finalize: function () {
        // JavaScript to be fired on the Single Products Template, after the init JS
      },
    },

    // Knowledge Center Lobby Template
    page_template_knowledge_center_lobby_template: {
      init: function () {
        // JavaScript to be fired on Single Products Template

        function select_search(el, nro) {
          /* Custom select design */
          var select_list = "select-list-" + nro;

          el.append('<div class="button"></div>');
          el.append('<ul class="' + select_list + '"></ul>');
          el.find("select option").each(function () {
            if($(this).val() === 'all_types'){
              $("." + select_list).append(
                '<li class="clsAnchor" style="pointer-events:none;background-color: #000000">' +
                  '<span value="' + $(this).val() + '" >' + $(this).text() + '</span></li>');
            }
            else {
              $("." + select_list).append(
                '<li class="clsAnchor">' +
                  '<span value="' + $(this).val() + '" >' + $(this).text() + '</span></li>');
            }
          });
          el.find(".button").html(
            '<span>' + el.find("select").find(":selected").text() + '</span>' +
            '<a href="javascript:void(0);" class="select-list-link"></a>'
          );
          el.find("ul li").each(function () {
            if (
              $(this).find("span").text() ===
              el.find("select").find(":selected").text()
            ) {
              $(this).addClass("active");
            }
          });
          el.find("." + select_list + " span").on("click", function () {
            var dd_text = $(this).text();
            var dd_val = $(this).attr("value");
            el.find(".button").html(
              '<span>' + dd_text + '</span>' + '<a href="javascript:void(0);" class="select-list-link"></a>' );
            el.find("." + select_list + " span")
              .parent()
              .removeClass("active");
            $(this).parent().addClass("active");
            el.find("select[name=search-filter]").val(dd_val);

            el.find("." + select_list + " li").slideUp();
          });
          el.find(".button").on("click", "a.select-list-link", function () {
            el.find("ul li").slideToggle();
          });
          /* End */
        }

        select_search( $(".drop-down-0") , 0);

        function select_design(el, nro) {
          /* Custom select design */
          var select_list = "select-list-" + nro;

          el.append('<div class="button"></div>');
          el.append('<ul class="' + select_list + '"></ul>');
          el.find("select option").each(function () {
            var bg = $(this).css("background-image");
            $("." + select_list).append(
              '<li class="clsAnchor"><span value="' +
              $(this).val() +
              '" class="' +
              $(this).attr("class") +
              '" style=background-image:' +
              bg +
              ">" +
              $(this).text() +
              "</span></li>"
            );
          });
          el.find(".button").html(
            "<span style=background-image:" +
            el.find("select").find(":selected").css("background-image") +
            ">" +
            el.find("select").find(":selected").text() +
            "</span>" +
            '<a href="javascript:void(0);" class="select-list-link"></a>'
          );
          el.find("ul li").each(function () {
            if (
              $(this).find("span").text() ===
              el.find("select").find(":selected").text()
            ) {
              $(this).addClass("active");
            }
          });
          el.find("." + select_list + " span").on("click", function () {
            var dd_text = $(this).text();
            var dd_img = $(this).css("background-image");
            var dd_val = $(this).attr("value");
            el.find(".button").html(
              "<span style=background-image:" +
              dd_img +
              ">" +
              dd_text +
              "</span>" +
              '<a href="javascript:void(0);" class="select-list-link"></a>'
            );
            el.find("." + select_list + " span")
              .parent()
              .removeClass("active");
            $(this).parent().addClass("active");
            el.find("select[name=options]").val(dd_val);

            //update href link from selected option
            el.closest(".block-item-container")
              .find(".file-format")
              .attr("href", dd_val);

            el.find("." + select_list + " li").slideUp();
          });
          el.find(".button").on("click", "a.select-list-link", function () {
            el.find("ul li").slideToggle();
          });
          /* End */
        }

        var selectLength =
          $(".knowledge-center-items .blocks .block").length + 1;

        for (var i = 1; i <= selectLength; i++) {
          var selectLanguage = $(".drop-down-" + i);
          select_design(selectLanguage, i);
        }



        $(".blocks div[class^=drop-down-] .button").on("click", function () {
          var drop_down_clicked = $(this).parent().attr('class');
          $(this).parent().toggleClass('active');
          $(".blocks div[class^=drop-down-]").not($(this).parent()).removeClass('active');
          $(".blocks div[class^=drop-down-]").not('.active').find('ul[class^=select-list-] li').slideUp();
        });

        var searchForm = $(".knowledge-center-search form");

        searchForm.on("submit", function (e) {
          e.preventDefault();

          var search = searchForm.find("input").val();
          var search_filter = searchForm.find("select").val();

          if (!search_filter) {
            search_filter = "marketing";
          }

          // console.log(search);
          // console.log(search_filter);

          var linkFilter =
            window.location.protocol +
            "//" +
            window.location.host +
            "/" +
            search_filter +
            "/?search=" +
            search;

          //console.log(linkFilter);
          window.open(linkFilter, "_self");
        });

        if ($(window).width() < 768) {
          var knowledge_slider = $(".knowledge-center-items .blocks");

          // knowledge_slider.slick({
          //   dots: false,
          //   prevArrow: false,
          //   nextArrow: false,
          //   slidesToShow: 1,
          //   slidesToScroll: 1,
          rtl: $('body').hasClass('rtl'),
          // });

          knowledge_slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            rtl: $('body').hasClass('rtl'),
            autoplaySpeed: 2000,
            arrow: false,
            infinite: false,
            speed: 300,
            dots: true,
            // variableWidth: true,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  rtl: $('body').hasClass('rtl'),
                  variableWidth: false,
                },
              },
            ],
          });








          knowledge_slider.on("swipe", function () {
            // console.log("lo moviste");
            $(".slick-slider .slick-list").css("overflow", "hidden");
          });

          $(
            '.knowledge-center-items .blocks .block div[class^="drop-down-"] .button a'
          ).on("click", function () {
            var select_list = $(this)
              .parent()
              .next("ul")
              .find("li:first-child");

            //console.log(select_list.css('display'));

            if (select_list.css("display") === "none") {
              setTimeout(function () {
                $(".slick-slider .slick-list").css("overflow", "unset");
              }, 150);
            } else {
              setTimeout(function () {
                $(".slick-slider .slick-list").css("overflow", "hidden");
              }, 400);
            }

            // if ( $('.knowledge-center-items .blocks .block div[class^="drop-down-"] ul[class^="select-list"] li').css('display') === "list-item" ){
            //   $('.knowledge-center-items .blocks .slick-list').css('overflow', 'hidden');
            // }
          });
        }

        if ($(window).width() < 475) {
          $(".knowledge-center-search form input").attr(
            "placeholder",
            "Search ..."
          );
        }
      },
      finalize: function () {
        // JavaScript to be fired on the Single Products Template, after the init JS
      },
    },

    // Knowledge Center Internal Template
    page_template_knowledge_center_internal_template: {
      init: function () {
        // JavaScript to be fired on Single Products Template

        function select_search(el, nro) {
          /* Custom select design */
          var select_list = "select-list-" + nro;

          el.append('<div class="button"></div>');
          el.append('<ul class="' + select_list + '"></ul>');
          el.find("select option").each(function () {
            $("." + select_list).append(
              '<li class="clsAnchor">' +
              '<span value="' + $(this).val() + '" >' + $(this).text() + '</span></li>');
          });
          el.find(".button").html(
            '<span>' + el.find("select").find(":selected").text() + '</span>' +
            '<a href="javascript:void(0);" class="select-list-link"></a>'
          );
          el.find("ul li").each(function () {
            if (
              $(this).find("span").text() ===
              el.find("select").find(":selected").text()
            ) {
              $(this).addClass("active");
            }
          });
          el.find("." + select_list + " span").on("click", function () {
            var dd_text = $(this).text();
            var dd_val = $(this).attr("value");
            el.find(".button").html(
              '<span>' + dd_text + '</span>' + '<a href="javascript:void(0);" class="select-list-link"></a>' );
            el.find("." + select_list + " span")
              .parent()
              .removeClass("active");
            $(this).parent().addClass("active");
            el.find("select[name=search-filter]").val(dd_val);

            el.find("." + select_list + " li").slideUp();
          });
          el.find(".button").on("click", "a.select-list-link", function () {
            el.find("ul li").slideToggle();
          });
          /* End */
        }

        select_search( $(".drop-down-0") , 0);

        function select_design(el, nro) {
          /* Custom select design */
          var select_list = "select-list-" + nro;

          el.append('<div class="button"></div>');
          el.append('<ul class="' + select_list + '"></ul>');
          el.find("select option").each(function () {
            var bg = $(this).css("background-image");
            $("." + select_list).append(
              '<li class="clsAnchor"><span value="' +
              $(this).val() +
              '" class="' +
              $(this).attr("class") +
              '" style=background-image:' +
              bg +
              ">" +
              $(this).text() +
              "</span></li>"
            );
          });
          el.find(".button").html(
            "<span style=background-image:" +
            el.find("select").find(":selected").css("background-image") +
            ">" +
            el.find("select").find(":selected").text() +
            "</span>" +
            '<a href="javascript:void(0);" class="select-list-link"></a>'
          );
          el.find("ul li").each(function () {
            if (
              $(this).find("span").text() ===
              el.find("select").find(":selected").text()
            ) {
              $(this).addClass("active");
            }
          });
          el.find("." + select_list + " span").on("click", function () {
            var dd_text = $(this).text();
            var dd_img = $(this).css("background-image");
            var dd_val = $(this).attr("value");
            el.find(".button").html(
              "<span style=background-image:" +
              dd_img +
              ">" +
              dd_text +
              "</span>" +
              '<a href="javascript:void(0);" class="select-list-link"></a>'
            );
            el.find("." + select_list + " span")
              .parent()
              .removeClass("active");
            $(this).parent().addClass("active");
            el.find("select[name=options]").val(dd_val);

            //update href link from selected option
            el.closest(".details-column")
              .find(".item-description")
              .find(".file-format")
              .attr("href", dd_val);

            el.find("." + select_list + " li").slideUp();
          });
          el.find(".button").on("click", "a.select-list-link", function () {
            el.find("ul li").slideToggle();
          });
          /* End */
        }

        var selectLength =
          $(".knowledge-center-content .file-list .list-item").length + 1;

        for (var i = 1; i <= selectLength; i++) {
          var selectLanguage = $(".drop-down-" + i);
          select_design(selectLanguage, i);
        }

        var divFilters = $(".filter-sidebar > div");
        var file_list = $(".file-list-container .file-list");
        var searchForm = $(".knowledge-center-search form");

        //Search Result
        function searchResults() {

          var posttype = $(".filter-sidebar").attr("data-postype");

          /*
           *   INFORMATION TYPE FILTERS
           */
          var information_type = [];
          var terms_information_type = "";
          var information_type_li = $(".information-type > .filter-content ul li");

          //Check active elements
          if (information_type_li.length) {
            var h3Active1 = false;

            $.each(information_type_li, function (index, elem) {
              var check_information = $(this).find('input[type="checkbox"]');

              if (check_information.is(":checked")) {
                information_type.push(check_information.val());
                h3Active1 = true;
              }
            });

            if (h3Active1){
              $(".filter-sidebar .information-type > h3").addClass("active");
            }else{
              $(".filter-sidebar .information-type > h3").removeClass("active");
            }

            terms_information_type = information_type.join("|");
          }

          /***********************************************************/

          /*
           *   FILTER TYPE FILTERS
           */
          var filter_type = [];
          var terms_filter_type = "";
          var filter_type_li = $(".filter-type > .filter-content ul li");

          //Check active elements
          if (filter_type_li.length) {

            var h3Active2 = false;

            $.each(filter_type_li, function (index, elem) {
              var check_type = $(this).find('input[type="checkbox"]');

              if (check_type.is(":checked")) {
                filter_type.push(check_type.val());
                h3Active2 = true;
              }
            });

            if (h3Active2){
              $(".filter-sidebar .filter-type > h3").addClass("active");
            }else{
              $(".filter-sidebar .filter-type > h3").removeClass("active");
            }

            terms_filter_type = filter_type.join("|");
          }

          /***********************************************************/

          /*
           *   PRODUCT FAMILY FILTERS
           */
          var product_family = [];
          var terms_product_family = "";
          var product_family_li = $(".product-family > .filter-content ul li");

          //Check active elements
          if (product_family_li.length) {
            var h3Active3 = false;

            $.each(product_family_li, function (index, elem) {
              var check_product = $(this).find('input[type="checkbox"]');

              if (check_product.is(":checked")) {
                product_family.push(check_product.val());
                h3Active3 = true;
              }
            });

            if (h3Active3){
              $(".filter-sidebar .product-family > h3").addClass("active");
            }else{
              $(".filter-sidebar .product-family > h3").removeClass("active");
            }

            terms_product_family = product_family.join("|");
          }

          /***********************************************************/

          var search = searchForm.find("input").val();
          var search_filter = searchForm.find("select").val();

          var linkFilter =
            window.location.protocol + "//" + window.location.host + "/" + posttype +
            "/?terms_information_type=" + terms_information_type +
            "&terms_filter_type=" + terms_filter_type +
            "&terms_product_family=" + terms_product_family +
            "&search-filter=" + search_filter +
            "&search=" + search;


          file_list.animate(
            {opacity: 0},
            500,
            function () {
              $(".loader").show();

              file_list.load(linkFilter + " .items-container", function () {
                $(".loader").hide();

                var selectLength =
                  $(".knowledge-center-content .file-list .list-item").length + 1;

                for (var i = 1; i <= selectLength; i++) {
                  var selectLanguage = $(".drop-down-" + i);
                  select_design(selectLanguage, i);
                }

                file_list.animate(
                  {opacity: 1},
                  350,
                  function () {
                  }
                );
              });
            }
          );


          /*

          file_list.load(linkFilter + " .items-container", function () {
            $(".loader").hide();
            file_list.animate({ opacity: 1 }, 350, function () {});
          });

           */
        }

        //On Submit search form
        searchForm.on("submit", function (e) {
          e.preventDefault();
          searchResults();
        });

        //On Click Sidebar Checbox
        divFilters.find('input[type="checkbox"]').on("click", function () {
          searchResults( $(this) );
        });

        // clicking on pagination links
        file_list.on("click", ".page-nave-container a", function (e) {
          e.preventDefault();
          var linkPaginator = $(this).attr("href");

          file_list.animate(
            {opacity: 0},
            500,
            function () {
              $(".loader").show();

              file_list.load(linkPaginator + " .items-container", function () {
                $(".loader").hide();

                var selectLength =
                  $(".knowledge-center-content .file-list .list-item").length + 1;

                for (var i = 1; i <= selectLength; i++) {
                  var selectLanguage = $(".drop-down-" + i);
                  select_design(selectLanguage, i);
                }

                file_list.animate(
                  {opacity: 1},
                  350
                );
              });
            }
          );

          //
          // file_list.load(linkPaginator + " .items-container", function () {
          //   $(".loader").hide();
          //   file_list.animate({ opacity: 1 }, 350, function () {});
          // });


        });

        $(".knowledge-center-content .filter-sidebar > div h3").on(
          "click",
          function () {
            // $(this).toggleClass('active');
            $(this).parent().toggleClass("active");
          }
        );

        /*
        if ($(window).width() < 767) {
          $(
            ".knowledge-center-content .filter-sidebar > div:first-child"
          ).addClass("active");
          // $('.knowledge-center-content .filter-sidebar > div:first-child h3').addClass('active');
        }
        */

        if ($(window).width() < 475) {
          $(".knowledge-center-search form input").attr(
            "placeholder",
            "Search ..."
          );
        }
      },
      finalize: function () {
        // JavaScript to be fired on the Single Products Template, after the init JS
      },
    },

    // Case Study Template (lobby)
    page_template_case_study_template: {
      init: function () {
        // JavaScript to be fired on Single Products Template,

        var isMobile = false;

        if ($(".filter-container").hasClass("isMobile")) {
          isMobile = true;
        }

        $(".segment .segment-item a").on("click", function (e) {
          e.preventDefault();
          $(this).removeAttr("href");
        });

        $(".filter-options-item").on("click", function (e) {
          e.preventDefault();

          var meta_taxonomy = $(this).attr("data-taxonomy");
          var meta_term = $(this).attr("data-term");

          var linkFilter =
            window.location.protocol +
            "//" +
            window.location.host +
            "/case-studies/?term=" + meta_term;

          /* MOBILE DESIGN */
          if (isMobile) {
            var filterResults = $(this).next();

            /* if filter is active */
            if ($(this).hasClass("active")) {
              $(".filter-results.active .case-study-container").slideUp(
                750,
                function () {
                  $(".filter-results.active .case-study-container").remove();
                }
              );

              $(this).removeClass("active");
              $(this).find(".filter-name").removeClass("active");
              filterResults.removeClass("active");
            } else {
              /* if filter is not active */
              $(
                ".filter-options-item, .filter-options-item .filter-name, .filter-results"
              ).removeClass("active");

              $(this).addClass("active");
              $(this).find(".filter-name").addClass("active");
              filterResults.addClass("active");

              var scrollTo = $(".filter-container").offset().top;
              $("html, body").scrollTop(scrollTo);

              $(".case-study-container").slideUp(750, function () {
                $(".case-study-container").remove();
                $(".filter-results.active")
                  .load(linkFilter + " .case-study-container")
                  .animate({opacity: 1}, 500, function () {
                    $(".case-study-container").slideDown(750);
                  });
              });
            }
          } else {
            //DESKTOP DESIGN

            if (!$(this).hasClass("active")) {
              $(
                ".filter-options-item, .filter-options-item .filter-name"
              ).removeClass("active");
              $(this).addClass("active");
              $(this).find(".filter-name").addClass("active");
              //console.log(linkFilter);

              // animate loader on
              $(".case-study-container").animate(
                {opacity: 0},
                500,
                function () {
                  $(".loader").show();
                  $(".filter-results")
                    .load(linkFilter + " .case-study-container")
                    .animate({opacity: 1}, 500, function () {
                      $(".loader").hide();
                    });
                }
              );
            }
          }
        });

        $(".filter-options-item .segments >div").on("click", function (e) {
          e.preventDefault();
          var meta_taxonomy = $(this).attr("data-taxonomy");
          var meta_term = $(this).attr("data-term");

          // console.log(meta_taxonomy + " " + meta_term);
          var linkFilter =
            window.location.protocol +
            "//" +
            window.location.host +
            "/case-studies/?term=" + meta_term;

          // ONLY DESKTOP DESIGN (IN MOBILE THIS MENU IS HIDDEN)
          $(
            ".filter-options-item, .filter-options-item .filter-name"
          ).removeClass("active");
          $(this).closest(".filter-options-item").addClass("active");
          $(this)
            .closest(".filter-options-item")
            .find(".filter-name")
            .addClass("active");

          // animate loader on
          $(".case-study-container").animate({opacity: 0}, 500, function () {
            $(".loader").show();
            $(".filter-results")
              .load(linkFilter + " .case-study-container")
              .animate({opacity: 1}, 500, function () {
                $(".loader").hide();
              });
          });
        });

        $(".filter-results").on("click", ".page-nave-container a", function (e) {
          e.preventDefault();
          var linkPaginator = $(this).attr("href");

          var scrollTo = $(".filter-container").offset().top;
          $("html, body").scrollTop(scrollTo);

          $(".case-study-container").animate({opacity: 0}, 500, function () {
            $(".loader").show();
            $(this)
              .closest(".filter-results")
              .load(linkPaginator + " .case-study-container")
              .animate({opacity: 1}, 500, function () {
                $(".loader").hide();
              });
          });
        });
      },
      finalize: function () {
        // JavaScript to be fired on the Single Products Template, after the init JS
      },
    },

    // Blog Lobby Template
    page_template_blog_lobby_template: {
      init: function () {
        // JavaScript to be fired on Single Products Template,

        $(".promoted-post-block .block").on("click", function () {
          window.open($(this).attr("data-linkpost"), "_self");
        });

        var isMobile = false;

        $('.hero-search form img').on('click', function(){
          $(this).closest('form').submit();
        });

        if ($(".filter-container").hasClass("isMobile")) {
          isMobile = true;
        }

        if (isMobile){
          $('.promoted-post-block .block[tabindex="0"]').addClass('block-active');
        }

        $(".segment .segment-item a").on("click", function (e) {
          e.preventDefault();
          $(this).removeAttr("href");
        });

        $(".filter-options-item").on("click", function (e) {
          e.preventDefault();

          var meta_taxonomy = $(this).attr("data-taxonomy");
          var meta_term = $(this).attr("data-term");

          var linkFilter =
            window.location.protocol +
            "//" +
            window.location.host +
            "/blog-lobby/?term=" + meta_term;

          //MOBILE DESIGN
          if (isMobile) {
            var filterResults = $(this).next();

            //if filter is active
            if ($(this).hasClass("active")) {
              $(".filter-results.active .blog-lobby-container").slideUp(
                750,
                function () {
                  $(".filter-results.active .blog-lobby-container").remove();
                }
              );

              $(this).removeClass("active");
              $(this).find(".filter-name").removeClass("active");
              filterResults.removeClass("active");
            } else {
              //if filter is not active

              $(
                ".filter-options-item, .filter-options-item .filter-name, .filter-results"
              ).removeClass("active");

              $(this).addClass("active");
              $(this).find(".filter-name").addClass("active");
              filterResults.addClass("active");

              var scrollTo = $(".filter-container").offset().top;
              $("html, body").scrollTop(scrollTo);

              $(".blog-lobby-container").slideUp(750, function () {
                $(".blog-lobby-container").remove();
                $(".filter-results.active")
                  .load(linkFilter + " .blog-lobby-container")
                  .animate({opacity: 1}, 500, function () {
                    $(".blog-lobby-container").slideDown(750);
                  });
              });
            }
          } else {
            //DESKTOP DESIGN
            if (!$(this).hasClass("active")) {
              $(
                ".filter-options-item, .filter-options-item .filter-name"
              ).removeClass("active");
              $(this).addClass("active");
              $(this).find(".filter-name").addClass("active");
              //console.log(linkFilter);

              // animate loader on
              $(".blog-lobby-container").animate(
                {opacity: 0},
                500,
                function () {
                  $(".loader").show();
                  $(".filter-results")
                    .load(linkFilter + " .blog-lobby-container")
                    .animate({opacity: 1}, 500, function () {
                      $(".loader").hide();
                    });
                }
              );
            }
          }
        });

        $(".filter-options-item .segments >div").on("click", function (e) {
          e.preventDefault();
          var meta_taxonomy = $(this).attr("data-taxonomy");
          var meta_term = $(this).attr("data-term");

          // console.log(meta_taxonomy + " " + meta_term);
          var linkFilter =
            window.location.protocol +
            "//" +
            window.location.host +
            "/blog-lobby/?term=" + meta_term;

          // ONLY DESKTOP DESIGN (IN MOBILE THIS MENU IS HIDDEN)
          $(
            ".filter-options-item, .filter-options-item .filter-name"
          ).removeClass("active");
          $(this).closest(".filter-options-item").addClass("active");
          $(this)
            .closest(".filter-options-item")
            .find(".filter-name")
            .addClass("active");

          // animate loader on
          $(".blog-lobby-container").animate({opacity: 0}, 500, function () {
            $(".loader").show();
            $(".filter-results")
              .load(linkFilter + " .blog-lobby-container")
              .animate({opacity: 1}, 500, function () {
                $(".loader").hide();
              });
          });
        });

        $(".filter-results").on("click", ".page-nave-container a", function (
          e
        ) {
          e.preventDefault();
          var linkPaginator = $(this).attr("href");

          var scrollTo = $(".filter-container").offset().top;
          $("html, body").scrollTop(scrollTo);

          $(".blog-lobby-container").animate({opacity: 0}, 500, function () {
            $(".loader").show();
            $(this)
              .closest(".filter-results")
              .load(linkPaginator + " .blog-lobby-container")
              .animate({opacity: 1}, 500, function () {
                $(".loader").hide();
              });
          });
        });
      },
      finalize: function () {
        // JavaScript to be fired on the Single Products Template, after the init JS
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, "_").split(/\s+/), function (
        i,
        classnm
      ) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, "finalize");
      });

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
